webpackJsonp([114276838955818,60335399758886],{

/***/ 601:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"siteTitle":"Healthful&Inspired: The best site to find health and weight loss reads","siteName":"Healthful&Inspired","siteUrl":"https://healthfulinspired.com","siteDescription":"Actively sharing the most useful health content for health, wellness, fitness, weight loss, fat burn & diets for people who want to become healthier. Subscribe!"}}},"layoutContext":{}}

/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(970);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(601);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _helpers = __webpack_require__(35);
	
	var _Paper = _interopRequireDefault(__webpack_require__(78));
	
	// @inheritedComponent Paper
	var styles = function styles(theme) {
	  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: 'column',
	      width: '100%',
	      boxSizing: 'border-box',
	      // Prevent padding issue with the Modal and fixed positioned AppBar.
	      zIndex: theme.zIndex.appBar,
	      flexShrink: 0
	    },
	    positionFixed: {
	      position: 'fixed',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	    positionAbsolute: {
	      position: 'absolute',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	    positionSticky: {
	      position: 'sticky',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	    positionStatic: {
	      position: 'static'
	    },
	    colorDefault: {
	      backgroundColor: backgroundColorDefault,
	      color: theme.palette.getContrastText(backgroundColorDefault)
	    },
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    }
	  };
	};
	
	exports.styles = styles;
	
	function AppBar(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      position = props.position,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "position"]);
	  var className = (0, _classnames.default)(classes.root, classes["position".concat((0, _helpers.capitalize)(position))], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, 'mui-fixed', position === 'fixed'), _classNames), classNameProp);
	  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    component: "header",
	    elevation: 4,
	    className: className
	  }, other), children);
	}
	
	AppBar.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'default']),
	
	  /**
	   * The positioning type. The behavior of the different options is described
	   * [here](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
	   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
	   */
	  position: _propTypes.default.oneOf(['fixed', 'absolute', 'sticky', 'static'])
	} : {};
	AppBar.defaultProps = {
	  color: 'primary',
	  position: 'fixed'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAppBar'
	})(AppBar);
	
	exports.default = _default;

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _AppBar.default;
	  }
	});
	
	var _AppBar = _interopRequireDefault(__webpack_require__(154));

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _Fade = _interopRequireDefault(__webpack_require__(128));
	
	var styles = {
	  root: {
	    zIndex: -1,
	    width: '100%',
	    height: '100%',
	    position: 'fixed',
	    top: 0,
	    left: 0,
	    // Remove grey highlight
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'rgba(0, 0, 0, 0.5)'
	  },
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	exports.styles = styles;
	
	function Backdrop(props) {
	  var classes = props.classes,
	      className = props.className,
	      invisible = props.invisible,
	      open = props.open,
	      transitionDuration = props.transitionDuration,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "invisible", "open", "transitionDuration"]);
	  return _react.default.createElement(_Fade.default, (0, _extends2.default)({
	    appear: true,
	    "in": open,
	    timeout: transitionDuration
	  }, other), _react.default.createElement("div", {
	    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.invisible, invisible), className),
	    "aria-hidden": "true"
	  }));
	}
	
	Backdrop.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : {};
	Backdrop.defaultProps = {
	  invisible: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBackdrop'
	})(Backdrop);
	
	exports.default = _default;

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Backdrop.default;
	  }
	});
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(156));

/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(24));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(93));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(33));
	
	// @inheritedComponent EventListener
	var isDescendant = function isDescendant(el, target) {
	  if (target !== null && target.parentNode) {
	    return el === target || isDescendant(el, target.parentNode);
	  }
	
	  return false;
	};
	/**
	 * Listen for click events that are triggered outside of the component children.
	 */
	
	
	var ClickAwayListener =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ClickAwayListener, _React$Component);
	
	  function ClickAwayListener() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, ClickAwayListener);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "mounted", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: false
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleClickAway", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        // Ignore events that have been `event.preventDefault()` marked.
	        if (event.defaultPrevented) {
	          return;
	        } // IE11 support, which trigger the handleClickAway even after the unbind
	
	
	        if (!_this.mounted) {
	          return;
	        }
	
	        var el = _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)(_this));
	
	        var doc = (0, _ownerDocument.default)(el);
	
	        if (doc.documentElement && doc.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
	          _this.props.onClickAway(event);
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(ClickAwayListener, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          mouseEvent = _props.mouseEvent,
	          touchEvent = _props.touchEvent,
	          onClickAway = _props.onClickAway,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "mouseEvent", "touchEvent", "onClickAway"]);
	      var listenerProps = {};
	
	      if (mouseEvent !== false) {
	        listenerProps[mouseEvent] = this.handleClickAway;
	      }
	
	      if (touchEvent !== false) {
	        listenerProps[touchEvent] = this.handleClickAway;
	      }
	
	      return _react.default.createElement(_reactEventListener.default, (0, _extends2.default)({
	        target: "document"
	      }, listenerProps, other), children);
	    }
	  }]);
	  return ClickAwayListener;
	}(_react.default.Component);
	
	ClickAwayListener.propTypes =  false ? {
	  children: _propTypes.default.node.isRequired,
	  mouseEvent: _propTypes.default.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),
	  onClickAway: _propTypes.default.func.isRequired,
	  touchEvent: _propTypes.default.oneOf(['onTouchStart', 'onTouchEnd', false])
	} : {};
	ClickAwayListener.defaultProps = {
	  mouseEvent: 'onMouseUp',
	  touchEvent: 'onTouchEnd'
	};
	var _default = ClickAwayListener;
	exports.default = _default;

/***/ }),

/***/ 866:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ClickAwayListener.default;
	  }
	});
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(865));

/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _styles = __webpack_require__(771);
	
	var _exactProp = _interopRequireDefault(__webpack_require__(211));
	
	var styles = function styles(theme) {
	  return {
	    '@global': {
	      html: {
	        WebkitFontSmoothing: 'antialiased',
	        // Antialiasing.
	        MozOsxFontSmoothing: 'grayscale',
	        // Antialiasing.
	        // Change from `box-sizing: content-box` so that `width`
	        // is not affected by `padding` or `border`.
	        boxSizing: 'border-box'
	      },
	      '*, *::before, *::after': {
	        boxSizing: 'inherit'
	      },
	      body: {
	        margin: 0,
	        // Remove the margin in all browsers.
	        backgroundColor: theme.palette.background.default,
	        '@media print': {
	          // Save printer ink.
	          backgroundColor: theme.palette.common.white
	        }
	      }
	    }
	  };
	};
	/**
	 * Kickstart an elegant, consistent, and simple baseline to build upon.
	 */
	
	
	var CssBaseline =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(CssBaseline, _React$Component);
	
	  function CssBaseline() {
	    (0, _classCallCheck2.default)(this, CssBaseline);
	    return (0, _possibleConstructorReturn2.default)(this, (CssBaseline.__proto__ || (0, _getPrototypeOf.default)(CssBaseline)).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(CssBaseline, [{
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return CssBaseline;
	}(_react.default.Component);
	
	CssBaseline.propTypes =  false ? {
	  /**
	   * You can only provide a single element with react@15, a node with react@16.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired
	} : {};
	CssBaseline.propTypes =  false ? (0, _exactProp.default)(CssBaseline.propTypes, 'CssBaseline') : {};
	CssBaseline.defaultProps = {
	  children: null
	};
	
	var _default = (0, _styles.withStyles)(styles, {
	  name: 'MuiCssBaseline'
	})(CssBaseline);
	
	exports.default = _default;

/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CssBaseline.default;
	  }
	});
	
	var _CssBaseline = _interopRequireDefault(__webpack_require__(867));

/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isHorizontal = isHorizontal;
	exports.getAnchor = getAnchor;
	exports.default = exports.styles = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(19));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _Modal = _interopRequireDefault(__webpack_require__(129));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _Slide = _interopRequireDefault(__webpack_require__(769));
	
	var _Paper = _interopRequireDefault(__webpack_require__(78));
	
	var _helpers = __webpack_require__(35);
	
	var _transitions = __webpack_require__(105);
	
	var oppositeDirection = {
	  left: 'right',
	  right: 'left',
	  top: 'down',
	  bottom: 'up'
	};
	
	function isHorizontal(props) {
	  return ['left', 'right'].indexOf(props.anchor) !== -1;
	}
	
	function getAnchor(props) {
	  return props.theme.direction === 'rtl' && isHorizontal(props) ? oppositeDirection[props.anchor] : props.anchor;
	}
	
	var styles = function styles(theme) {
	  return {
	    docked: {
	      flex: '0 0 auto'
	    },
	    paper: {
	      overflowY: 'auto',
	      display: 'flex',
	      flexDirection: 'column',
	      height: '100vh',
	      flex: '1 0 auto',
	      zIndex: theme.zIndex.drawer,
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      // temporary style
	      position: 'fixed',
	      top: 0,
	      // We disable the focus ring for mouse, touch and keyboard users.
	      // At some point, it would be better to keep it for keyboard users.
	      // :focus-ring CSS pseudo-class will help.
	      outline: 'none'
	    },
	    paperAnchorLeft: {
	      left: 0,
	      right: 'auto'
	    },
	    paperAnchorRight: {
	      left: 'auto',
	      right: 0
	    },
	    paperAnchorTop: {
	      top: 0,
	      left: 0,
	      bottom: 'auto',
	      right: 0,
	      height: 'auto',
	      maxHeight: '100vh'
	    },
	    paperAnchorBottom: {
	      top: 'auto',
	      left: 0,
	      bottom: 0,
	      right: 0,
	      height: 'auto',
	      maxHeight: '100vh'
	    },
	    paperAnchorDockedLeft: {
	      borderRight: "1px solid ".concat(theme.palette.divider)
	    },
	    paperAnchorDockedTop: {
	      borderBottom: "1px solid ".concat(theme.palette.divider)
	    },
	    paperAnchorDockedRight: {
	      borderLeft: "1px solid ".concat(theme.palette.divider)
	    },
	    paperAnchorDockedBottom: {
	      borderTop: "1px solid ".concat(theme.palette.divider)
	    },
	    modal: {} // Just here so people can override the style.
	
	  };
	};
	/**
	 * The properties of the [Modal](/api/modal) component are available
	 * when `variant="temporary"` is set.
	 */
	
	
	exports.styles = styles;
	
	var Drawer =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Drawer, _React$Component);
	
	  function Drawer() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Drawer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Drawer.__proto__ || (0, _getPrototypeOf.default)(Drawer)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "mounted", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: false
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(Drawer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	    } // Let's assume that the Drawer will always be rendered on user space.
	    // We use that state is order to skip the appear transition during the
	    // initial mount of the component.
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          anchorProp = _props.anchor,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          elevation = _props.elevation,
	          _props$ModalProps = _props.ModalProps;
	      _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
	      var BackdropPropsProp = _props$ModalProps.BackdropProps,
	          ModalProps = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
	          onClose = _props.onClose,
	          open = _props.open,
	          PaperProps = _props.PaperProps,
	          SlideProps = _props.SlideProps,
	          theme = _props.theme,
	          transitionDuration = _props.transitionDuration,
	          variant = _props.variant,
	          other = (0, _objectWithoutProperties2.default)(_props, ["anchor", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "theme", "transitionDuration", "variant"]);
	      var anchor = getAnchor(this.props);
	
	      var drawer = _react.default.createElement(_Paper.default, (0, _extends2.default)({
	        elevation: variant === 'temporary' ? elevation : 0,
	        square: true,
	        className: (0, _classnames.default)(classes.paper, classes["paperAnchor".concat((0, _helpers.capitalize)(anchor))], (0, _defineProperty2.default)({}, classes["paperAnchorDocked".concat((0, _helpers.capitalize)(anchor))], variant !== 'temporary'))
	      }, PaperProps), children);
	
	      if (variant === 'permanent') {
	        return _react.default.createElement("div", (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.docked, className)
	        }, other), drawer);
	      }
	
	      var slidingDrawer = _react.default.createElement(_Slide.default, (0, _extends2.default)({
	        "in": open,
	        direction: oppositeDirection[anchor],
	        timeout: transitionDuration,
	        appear: this.mounted
	      }, SlideProps), drawer);
	
	      if (variant === 'persistent') {
	        return _react.default.createElement("div", (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.docked, className)
	        }, other), slidingDrawer);
	      } // variant === temporary
	
	
	      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
	        BackdropProps: (0, _objectSpread2.default)({}, BackdropPropsProp, {
	          transitionDuration: transitionDuration
	        }),
	        className: (0, _classnames.default)(classes.modal, className),
	        open: open,
	        onClose: onClose
	      }, other, ModalProps), slidingDrawer);
	    }
	  }]);
	  return Drawer;
	}(_react.default.Component);
	
	Drawer.propTypes =  false ? {
	  /**
	   * Side from which the drawer will appear.
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),
	
	  /**
	   * The contents of the drawer.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The elevation of the drawer.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * Properties applied to the `Modal` element.
	   */
	  ModalProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Properties applied to the `Paper` element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Properties applied to the `Slide` element.
	   */
	  SlideProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * The variant of drawer.
	   */
	  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : {};
	Drawer.defaultProps = {
	  anchor: 'left',
	  elevation: 16,
	  open: false,
	  transitionDuration: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  },
	  variant: 'temporary' // Mobile first.
	
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDrawer',
	  flip: false,
	  withTheme: true
	})(Drawer);
	
	exports.default = _default;

/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.default;
	  }
	});
	
	var _Drawer = _interopRequireDefault(__webpack_require__(869));

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _Input = __webpack_require__(104);
	
	var _helpers = __webpack_require__(35);
	
	var _reactHelpers = __webpack_require__(168);
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'inline-flex',
	      flexDirection: 'column',
	      position: 'relative',
	      // Reset fieldset default style
	      minWidth: 0,
	      padding: 0,
	      margin: 0,
	      border: 0
	    },
	    marginNormal: {
	      marginTop: theme.spacing.unit * 2,
	      marginBottom: theme.spacing.unit
	    },
	    marginDense: {
	      marginTop: theme.spacing.unit,
	      marginBottom: theme.spacing.unit / 2
	    },
	    fullWidth: {
	      width: '100%'
	    }
	  };
	};
	/**
	 * Provides context such as filled/focused/error/required for form inputs.
	 * Relying on the context provides high flexibilty and ensures that the state always stay
	 * consitent across the children of the `FormControl`.
	 * This context is used by the following components:
	 *  - FormLabel
	 *  - FormHelperText
	 *  - Input
	 *  - InputLabel
	 */
	
	
	exports.styles = styles;
	
	var FormControl =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(FormControl, _React$Component);
	
	  function FormControl(props, context) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, FormControl);
	    _this = (0, _possibleConstructorReturn2.default)(this, (FormControl.__proto__ || (0, _getPrototypeOf.default)(FormControl)).call(this, props, context)); // We need to iterate through the children and find the Input in order
	    // to fully support server side rendering.
	
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "state", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: {
	        adornedStart: false,
	        filled: false,
	        focused: false
	      }
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleFocus", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        if (_this.props.onFocus) {
	          _this.props.onFocus(event);
	        }
	
	        _this.setState(function (state) {
	          return !state.focused ? {
	            focused: true
	          } : null;
	        });
	      }
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleBlur", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        // The event might be undefined.
	        // For instance, a child component might call this hook
	        // when an input is disabled but still having the focus.
	        if (_this.props.onBlur && event) {
	          _this.props.onBlur(event);
	        }
	
	        _this.setState(function (state) {
	          return state.focused ? {
	            focused: false
	          } : null;
	        });
	      }
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleDirty", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        if (!_this.state.filled) {
	          _this.setState({
	            filled: true
	          });
	        }
	      }
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleClean", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        if (_this.state.filled) {
	          _this.setState({
	            filled: false
	          });
	        }
	      }
	    });
	    var children = _this.props.children;
	
	    if (children) {
	      _react.default.Children.forEach(children, function (child) {
	        if (!(0, _reactHelpers.isMuiElement)(child, ['Input', 'Select'])) {
	          return;
	        }
	
	        if ((0, _Input.isFilled)(child.props, true)) {
	          _this.state.filled = true;
	        }
	
	        var input = (0, _reactHelpers.isMuiElement)(child, ['Select']) ? child.props.input : child;
	
	        if (input && (0, _Input.isAdornedStart)(input.props)) {
	          _this.state.adornedStart = true;
	        }
	      });
	    }
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(FormControl, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          error = _props.error,
	          required = _props.required,
	          margin = _props.margin;
	      var _state = this.state,
	          adornedStart = _state.adornedStart,
	          filled = _state.filled,
	          focused = _state.focused;
	      return {
	        muiFormControl: {
	          adornedStart: adornedStart,
	          disabled: disabled,
	          error: error,
	          filled: filled,
	          focused: focused,
	          margin: margin,
	          onBlur: this.handleBlur,
	          onEmpty: this.handleClean,
	          onFilled: this.handleDirty,
	          onFocus: this.handleFocus,
	          required: required
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _props2 = this.props,
	          classes = _props2.classes,
	          className = _props2.className,
	          Component = _props2.component,
	          disabled = _props2.disabled,
	          error = _props2.error,
	          fullWidth = _props2.fullWidth,
	          margin = _props2.margin,
	          required = _props2.required,
	          other = (0, _objectWithoutProperties2.default)(_props2, ["classes", "className", "component", "disabled", "error", "fullWidth", "margin", "required"]);
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["margin".concat((0, _helpers.capitalize)(margin))], margin !== 'none'), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), _classNames), className)
	      }, other, {
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur
	      }));
	    }
	  }]);
	  return FormControl;
	}(_react.default.Component);
	
	FormControl.propTypes =  false ? {
	  /**
	   * The contents of the form control.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * If `true`, the label, input and helper text should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool
	} : {};
	FormControl.defaultProps = {
	  component: 'div',
	  disabled: false,
	  error: false,
	  fullWidth: false,
	  margin: 'none',
	  required: false
	};
	FormControl.childContextTypes = {
	  muiFormControl: _propTypes.default.object
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormControl'
	})(FormControl);
	
	exports.default = _default;

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormControl.default;
	  }
	});
	
	var _FormControl = _interopRequireDefault(__webpack_require__(239));

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      fontFamily: theme.typography.fontFamily,
	      color: theme.palette.text.secondary,
	      fontSize: theme.typography.pxToRem(16),
	      lineHeight: 1,
	      padding: 0,
	      '&$focused': {
	        color: theme.palette.primary[theme.palette.type === 'light' ? 'dark' : 'light']
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    },
	    focused: {},
	    disabled: {},
	    error: {},
	    asterisk: {
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	function FormLabel(props, context) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      disabledProp = props.disabled,
	      errorProp = props.error,
	      focusedProp = props.focused,
	      requiredProp = props.required,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disabled", "error", "focused", "required"]);
	  var muiFormControl = context.muiFormControl;
	  var required = requiredProp;
	  var focused = focusedProp;
	  var disabled = disabledProp;
	  var error = errorProp;
	
	  if (muiFormControl) {
	    if (typeof required === 'undefined') {
	      required = muiFormControl.required;
	    }
	
	    if (typeof focused === 'undefined') {
	      focused = muiFormControl.focused;
	    }
	
	    if (typeof disabled === 'undefined') {
	      disabled = muiFormControl.disabled;
	    }
	
	    if (typeof error === 'undefined') {
	      error = muiFormControl.error;
	    }
	  }
	
	  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.focused, focused), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.error, error), _classNames), classNameProp);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className
	  }, other), children, required && _react.default.createElement("span", {
	    className: (0, _classnames.default)(classes.asterisk, (0, _defineProperty2.default)({}, classes.error, error))
	  }, "\u2009*"));
	}
	
	FormLabel.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * If `true`, the label should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input of this label is focused (used by `FormGroup` components).
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool
	} : {};
	FormLabel.defaultProps = {
	  component: 'label'
	};
	FormLabel.contextTypes = {
	  muiFormControl: _propTypes.default.object
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormLabel'
	})(FormLabel);
	
	exports.default = _default;

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormLabel.default;
	  }
	});
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(242));

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(19));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Transition = _interopRequireDefault(__webpack_require__(103));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(130));
	
	var _utils = __webpack_require__(167);
	
	// @inheritedComponent Transition
	function getScale(value) {
	  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
	}
	
	var styles = {
	  entering: {
	    opacity: 1,
	    transform: getScale(1)
	  },
	  entered: {
	    opacity: 1,
	    transform: getScale(1)
	  }
	};
	/**
	 * The Grow transition is used by the [Popover](/utils/popovers) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Grow =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Grow, _React$Component);
	
	  function Grow() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Grow);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Grow.__proto__ || (0, _getPrototypeOf.default)(Grow)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "autoTimeout", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: undefined
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "timer", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleEnter", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        var _this$props = _this.props,
	            theme = _this$props.theme,
	            timeout = _this$props.timeout;
	        (0, _utils.reflow)(node); // So the animation always start from the start.
	
	        var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
	          mode: 'enter'
	        }),
	            transitionDuration = _getTransitionProps.duration,
	            delay = _getTransitionProps.delay;
	
	        var duration = 0;
	
	        if (timeout === 'auto') {
	          duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	          _this.autoTimeout = duration;
	        } else {
	          duration = transitionDuration;
	        }
	
	        node.style.transition = [theme.transitions.create('opacity', {
	          duration: duration,
	          delay: delay
	        }), theme.transitions.create('transform', {
	          duration: duration * 0.666,
	          delay: delay
	        })].join(',');
	
	        if (_this.props.onEnter) {
	          _this.props.onEnter(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleExit", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        var _this$props2 = _this.props,
	            theme = _this$props2.theme,
	            timeout = _this$props2.timeout;
	        var duration = 0;
	
	        var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
	          mode: 'exit'
	        }),
	            transitionDuration = _getTransitionProps2.duration,
	            delay = _getTransitionProps2.delay;
	
	        if (timeout === 'auto') {
	          duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	          _this.autoTimeout = duration;
	        } else {
	          duration = transitionDuration;
	        }
	
	        node.style.transition = [theme.transitions.create('opacity', {
	          duration: duration,
	          delay: delay
	        }), theme.transitions.create('transform', {
	          duration: duration * 0.666,
	          delay: delay || duration * 0.333
	        })].join(',');
	        node.style.opacity = '0';
	        node.style.transform = getScale(0.75);
	
	        if (_this.props.onExit) {
	          _this.props.onExit(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "addEndListener", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(_, next) {
	        if (_this.props.timeout === 'auto') {
	          _this.timer = setTimeout(next, _this.autoTimeout || 0);
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(Grow, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timer);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          onEnter = _props.onEnter,
	          onExit = _props.onExit,
	          styleProp = _props.style,
	          theme = _props.theme,
	          timeout = _props.timeout,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "onEnter", "onExit", "style", "theme", "timeout"]);
	      var style = (0, _objectSpread2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
	      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        appear: true,
	        onEnter: this.handleEnter,
	        onExit: this.handleExit,
	        addEndListener: this.addEndListener,
	        timeout: timeout === 'auto' ? null : timeout
	      }, other), function (state, childProps) {
	        return _react.default.cloneElement(children, (0, _objectSpread2.default)({
	          style: (0, _objectSpread2.default)({
	            opacity: 0,
	            transform: getScale(0.75)
	          }, styles[state], style)
	        }, childProps));
	      });
	    }
	  }]);
	  return Grow;
	}(_react.default.Component);
	
	Grow.propTypes =  false ? {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  }), _propTypes.default.oneOf(['auto'])])
	} : {};
	Grow.defaultProps = {
	  timeout: 'auto'
	};
	
	var _default = (0, _withTheme.default)()(Grow);
	
	exports.default = _default;

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grow.default;
	  }
	});
	
	var _Grow = _interopRequireDefault(__webpack_require__(244));

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(243));
	
	// @inheritedComponent FormLabel
	var styles = function styles(theme) {
	  return {
	    root: {
	      transformOrigin: 'top left'
	    },
	    formControl: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      // slight alteration to spec spacing to match visual spec result
	      transform: "translate(0, ".concat(theme.spacing.unit * 3, "px) scale(1)")
	    },
	    marginDense: {
	      // Compensation for the `Input.inputDense` style.
	      transform: "translate(0, ".concat(theme.spacing.unit * 2.5 + 1, "px) scale(1)")
	    },
	    shrink: {
	      transform: 'translate(0, 1.5px) scale(0.75)',
	      transformOrigin: 'top left'
	    },
	    animated: {
	      transition: theme.transitions.create('transform', {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      })
	    }
	  };
	};
	
	exports.styles = styles;
	
	function InputLabel(props, context) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      disableAnimation = props.disableAnimation,
	      FormLabelClasses = props.FormLabelClasses,
	      marginProp = props.margin,
	      shrinkProp = props.shrink,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableAnimation", "FormLabelClasses", "margin", "shrink"]);
	  var muiFormControl = context.muiFormControl;
	  var shrink = shrinkProp;
	
	  if (typeof shrink === 'undefined' && muiFormControl) {
	    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
	  }
	
	  var margin = marginProp;
	
	  if (typeof margin === 'undefined' && muiFormControl) {
	    margin = muiFormControl.margin;
	  }
	
	  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty2.default)(_classNames, classes.animated, !disableAnimation), (0, _defineProperty2.default)(_classNames, classes.shrink, shrink), (0, _defineProperty2.default)(_classNames, classes.marginDense, margin === 'dense'), _classNames), classNameProp);
	  return _react.default.createElement(_FormLabel.default, (0, _extends2.default)({
	    "data-shrink": shrink,
	    className: className,
	    classes: FormLabelClasses
	  }, other), children);
	}
	
	InputLabel.propTypes =  false ? {
	  /**
	   * The contents of the `InputLabel`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the transition animation is disabled.
	   */
	  disableAnimation: _propTypes.default.bool,
	
	  /**
	   * If `true`, apply disabled class.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input of this label is focused.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * `classes` property applied to the `FormLabel` element.
	   */
	  FormLabelClasses: _propTypes.default.object,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense']),
	
	  /**
	   * if `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label is shrunk.
	   */
	  shrink: _propTypes.default.bool
	} : {};
	InputLabel.defaultProps = {
	  disableAnimation: false
	};
	InputLabel.contextTypes = {
	  muiFormControl: _propTypes.default.object
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputLabel'
	})(InputLabel);
	
	exports.default = _default;

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputLabel.default;
	  }
	});
	
	var _InputLabel = _interopRequireDefault(__webpack_require__(248));

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _warning = _interopRequireDefault(__webpack_require__(14));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _colorManipulator = __webpack_require__(55);
	
	var TRANSITION_DURATION = 4; // seconds
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      overflow: 'hidden',
	      height: 5
	    },
	    colorPrimary: {
	      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6)
	    },
	    colorSecondary: {
	      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4)
	    },
	    buffer: {
	      backgroundColor: 'transparent'
	    },
	    query: {
	      transform: 'rotate(180deg)'
	    },
	    dashed: {
	      position: 'absolute',
	      marginTop: 0,
	      height: '100%',
	      width: '100%',
	      animation: 'buffer 3s infinite linear'
	    },
	    dashedColorPrimary: {
	      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0px -23px'
	    },
	    dashedColorSecondary: {
	      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.6), " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0px -23px'
	    },
	    bar: {
	      width: '100%',
	      position: 'absolute',
	      left: 0,
	      bottom: 0,
	      top: 0,
	      transition: 'transform 0.2s linear',
	      transformOrigin: 'left'
	    },
	    barColorPrimary: {
	      backgroundColor: theme.palette.primary.main
	    },
	    barColorSecondary: {
	      backgroundColor: theme.palette.secondary.main
	    },
	    bar1Indeterminate: {
	      width: 'auto',
	      willChange: 'left, right',
	      animation: 'mui-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
	    },
	    bar2Indeterminate: {
	      width: 'auto',
	      willChange: 'left, right',
	      animation: 'mui-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
	      animationDelay: '1.15s'
	    },
	    bar1Determinate: {
	      willChange: 'transform',
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    bar1Buffer: {
	      zIndex: 1,
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    bar2Buffer: {
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    // Legends:
	    // || represents the viewport
	    // -  represents a light background
	    // x  represents a dark background
	    '@keyframes mui-indeterminate1': {
	      //  |-----|---x-||-----||-----|
	      '0%': {
	        left: '-35%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||xxxx-|
	      '60%': {
	        left: '100%',
	        right: '-90%'
	      },
	      '100%': {
	        left: '100%',
	        right: '-90%'
	      }
	    },
	    '@keyframes mui-indeterminate2': {
	      //  |xxxxx|xxxxx||-----||-----|
	      '0%': {
	        left: '-200%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||-x----|
	      '60%': {
	        left: '107%',
	        right: '-8%'
	      },
	      '100%': {
	        left: '107%',
	        right: '-8%'
	      }
	    },
	    '@keyframes buffer': {
	      '0%': {
	        opacity: 1,
	        backgroundPosition: '0px -23px'
	      },
	      '50%': {
	        opacity: 0,
	        backgroundPosition: '0px -23px'
	      },
	      '100%': {
	        opacity: 1,
	        backgroundPosition: '-200px -23px'
	      }
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	
	function LinearProgress(props) {
	  var _classNames, _classNames2, _classNames3, _classNames4;
	
	  var classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      value = props.value,
	      valueBuffer = props.valueBuffer,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
	  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.colorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.colorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.buffer, variant === 'buffer'), (0, _defineProperty2.default)(_classNames, classes.query, variant === 'query'), _classNames), classNameProp);
	  var dashedClass = (0, _classnames.default)(classes.dashed, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.dashedColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames2, classes.dashedColorSecondary, color === 'secondary'), _classNames2));
	  var bar1ClassName = (0, _classnames.default)(classes.bar, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.barColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames3, classes.barColorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames3, classes.bar1Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames3, classes.bar1Determinate, variant === 'determinate'), (0, _defineProperty2.default)(_classNames3, classes.bar1Buffer, variant === 'buffer'), _classNames3));
	  var bar2ClassName = (0, _classnames.default)(classes.bar, (_classNames4 = {}, (0, _defineProperty2.default)(_classNames4, classes.barColorPrimary, color === 'primary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorPrimary, color === 'primary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.barColorSecondary, color === 'secondary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorSecondary, color === 'secondary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.bar2Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames4, classes.bar2Buffer, variant === 'buffer'), _classNames4));
	  var rootProps = {};
	  var inlineStyles = {
	    bar1: {},
	    bar2: {}
	  };
	
	  if (variant === 'determinate' || variant === 'buffer') {
	    if (value !== undefined) {
	      rootProps['aria-valuenow'] = Math.round(value);
	      inlineStyles.bar1.transform = "scaleX(".concat(value / 100, ")");
	    } else {
	       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a value property ' + 'when using the determinate or buffer variant of LinearProgress .') : void 0;
	    }
	  }
	
	  if (variant === 'buffer') {
	    if (valueBuffer !== undefined) {
	      inlineStyles.bar2.transform = "scaleX(".concat((valueBuffer || 0) / 100, ")");
	    } else {
	       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a valueBuffer property ' + 'when using the buffer variant of LinearProgress.') : void 0;
	    }
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: className,
	    role: "progressbar"
	  }, rootProps, other), variant === 'buffer' ? _react.default.createElement("div", {
	    className: dashedClass
	  }) : null, _react.default.createElement("div", {
	    className: bar1ClassName,
	    style: inlineStyles.bar1
	  }), variant === 'determinate' ? null : _react.default.createElement("div", {
	    className: bar2ClassName,
	    style: inlineStyles.bar2
	  }));
	}
	
	LinearProgress.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The value of the progress indicator for the determinate and buffer variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The value for the buffer variant.
	   * Value between 0 and 100.
	   */
	  valueBuffer: _propTypes.default.number,
	
	  /**
	   * The variant of progress indicator. Use indeterminate or query
	   * when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
	} : {};
	LinearProgress.defaultProps = {
	  color: 'primary',
	  variant: 'indeterminate'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiLinearProgress'
	})(LinearProgress);
	
	exports.default = _default;

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _LinearProgress.default;
	  }
	});
	
	var _LinearProgress = _interopRequireDefault(__webpack_require__(158));

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(19));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(24));
	
	var _scrollbarSize = _interopRequireDefault(__webpack_require__(98));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _Popover = _interopRequireDefault(__webpack_require__(255));
	
	var _MenuList = _interopRequireDefault(__webpack_require__(253));
	
	// @inheritedComponent Popover
	var RTL_ORIGIN = {
	  vertical: 'top',
	  horizontal: 'right'
	};
	var LTR_ORIGIN = {
	  vertical: 'top',
	  horizontal: 'left'
	};
	var styles = {
	  paper: {
	    // specZ: The maximum height of a simple menu should be one or more rows less than the view
	    // height. This ensures a tappable area outside of the simple menu with which to dismiss
	    // the menu.
	    maxHeight: 'calc(100vh - 96px)',
	    // Add iOS momentum scrolling.
	    WebkitOverflowScrolling: 'touch'
	  }
	};
	exports.styles = styles;
	
	var Menu =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Menu, _React$Component);
	
	  function Menu() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Menu);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Menu.__proto__ || (0, _getPrototypeOf.default)(Menu)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "getContentAnchorEl", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        if (!_this.menuList || !_this.menuList.selectedItem) {
	          return _reactDom.default.findDOMNode(_this.menuList).firstChild;
	        }
	
	        return _reactDom.default.findDOMNode(_this.menuList.selectedItem);
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "menuList", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: undefined
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "focus", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        if (_this.menuList && _this.menuList.selectedItem) {
	          _reactDom.default.findDOMNode(_this.menuList.selectedItem).focus();
	
	          return;
	        }
	
	        var menuList = _reactDom.default.findDOMNode(_this.menuList);
	
	        if (menuList && menuList.firstChild) {
	          menuList.firstChild.focus();
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleEnter", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(element) {
	        var theme = _this.props.theme;
	
	        var menuList = _reactDom.default.findDOMNode(_this.menuList); // Focus so the scroll computation of the Popover works as expected.
	
	
	        _this.focus(); // Let's ignore that piece of logic if users are already overriding the width
	        // of the menu.
	
	
	        if (menuList && element.clientHeight < menuList.clientHeight && !menuList.style.width) {
	          var size = "".concat((0, _scrollbarSize.default)(), "px");
	          menuList.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = size;
	          menuList.style.width = "calc(100% + ".concat(size, ")");
	        }
	
	        if (_this.props.onEnter) {
	          _this.props.onEnter(element);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleListKeyDown", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event, key) {
	        if (key === 'tab') {
	          event.preventDefault();
	
	          if (_this.props.onClose) {
	            _this.props.onClose(event);
	          }
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(Menu, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.open) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          classes = _props.classes,
	          MenuListProps = _props.MenuListProps,
	          onEnter = _props.onEnter,
	          _props$PaperProps = _props.PaperProps,
	          PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	          PopoverClasses = _props.PopoverClasses,
	          theme = _props.theme,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "MenuListProps", "onEnter", "PaperProps", "PopoverClasses", "theme"]);
	      return _react.default.createElement(_Popover.default, (0, _extends2.default)({
	        getContentAnchorEl: this.getContentAnchorEl,
	        classes: PopoverClasses,
	        onEnter: this.handleEnter,
	        anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
	        transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
	        PaperProps: (0, _objectSpread2.default)({}, PaperProps, {
	          classes: (0, _objectSpread2.default)({}, PaperProps.classes, {
	            root: classes.paper
	          })
	        })
	      }, other), _react.default.createElement(_MenuList.default, (0, _extends2.default)({
	        role: "menu",
	        onKeyDown: this.handleListKeyDown
	      }, MenuListProps, {
	        ref: function ref(node) {
	          _this2.menuList = node;
	        }
	      }), children));
	    }
	  }]);
	  return Menu;
	}(_react.default.Component);
	
	Menu.propTypes =  false ? {
	  /**
	   * The DOM element used to set the position of the menu.
	   */
	  anchorEl: _propTypes.default.object,
	
	  /**
	   * Menu contents, normally `MenuItem`s.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * Properties applied to the `MenuList` element.
	   */
	  MenuListProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the Menu enters.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the Menu exits.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the menu is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * `classes` property applied to the `Popover` element.
	   */
	  PopoverClasses: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The length of the transition in `ms`, or 'auto'
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  }), _propTypes.default.oneOf(['auto'])])
	} : {};
	Menu.defaultProps = {
	  transitionDuration: 'auto'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMenu',
	  withTheme: true
	})(Menu);
	
	exports.default = _default;

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(82));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(24));
	
	var _keycode = _interopRequireDefault(__webpack_require__(58));
	
	var _contains = _interopRequireDefault(__webpack_require__(74));
	
	var _activeElement = _interopRequireDefault(__webpack_require__(190));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(33));
	
	var _List = _interopRequireDefault(__webpack_require__(250));
	
	// @inheritedComponent List
	var MenuList =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(MenuList, _React$Component);
	
	  function MenuList() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, MenuList);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = MenuList.__proto__ || (0, _getPrototypeOf.default)(MenuList)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "state", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: {
	        currentTabIndex: undefined
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "list", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: undefined
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "selectedItem", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: undefined
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "blurTimer", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: undefined
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleBlur", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        _this.blurTimer = setTimeout(function () {
	          if (_this.list) {
	            var list = _reactDom.default.findDOMNode(_this.list);
	
	            var currentFocus = (0, _activeElement.default)((0, _ownerDocument.default)(list));
	
	            if (!(0, _contains.default)(list, currentFocus)) {
	              _this.resetTabIndex();
	            }
	          }
	        }, 30);
	
	        if (_this.props.onBlur) {
	          _this.props.onBlur(event);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleKeyDown", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        var list = _reactDom.default.findDOMNode(_this.list);
	
	        var key = (0, _keycode.default)(event);
	        var currentFocus = (0, _activeElement.default)((0, _ownerDocument.default)(list));
	
	        if ((key === 'up' || key === 'down') && (!currentFocus || currentFocus && !(0, _contains.default)(list, currentFocus))) {
	          if (_this.selectedItem) {
	            _reactDom.default.findDOMNode(_this.selectedItem).focus();
	          } else {
	            list.firstChild.focus();
	          }
	        } else if (key === 'down') {
	          event.preventDefault();
	
	          if (currentFocus.nextElementSibling) {
	            currentFocus.nextElementSibling.focus();
	          }
	        } else if (key === 'up') {
	          event.preventDefault();
	
	          if (currentFocus.previousElementSibling) {
	            currentFocus.previousElementSibling.focus();
	          }
	        }
	
	        if (_this.props.onKeyDown) {
	          _this.props.onKeyDown(event, key);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleItemFocus", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        var list = _reactDom.default.findDOMNode(_this.list);
	
	        if (list) {
	          for (var i = 0; i < list.children.length; i += 1) {
	            if (list.children[i] === event.currentTarget) {
	              _this.setTabIndex(i);
	
	              break;
	            }
	          }
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(MenuList, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.resetTabIndex();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.blurTimer);
	    }
	  }, {
	    key: "setTabIndex",
	    value: function setTabIndex(index) {
	      this.setState({
	        currentTabIndex: index
	      });
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      var currentTabIndex = this.state.currentTabIndex;
	
	      var list = _reactDom.default.findDOMNode(this.list);
	
	      if (!list || !list.children || !list.firstChild) {
	        return;
	      }
	
	      if (currentTabIndex && currentTabIndex >= 0) {
	        list.children[currentTabIndex].focus();
	      } else {
	        list.firstChild.focus();
	      }
	    }
	  }, {
	    key: "resetTabIndex",
	    value: function resetTabIndex() {
	      var list = _reactDom.default.findDOMNode(this.list);
	
	      var currentFocus = (0, _activeElement.default)((0, _ownerDocument.default)(list));
	      var items = (0, _toConsumableArray2.default)(list.children);
	      var currentFocusIndex = items.indexOf(currentFocus);
	
	      if (currentFocusIndex !== -1) {
	        return this.setTabIndex(currentFocusIndex);
	      }
	
	      if (this.selectedItem) {
	        return this.setTabIndex(items.indexOf(_reactDom.default.findDOMNode(this.selectedItem)));
	      }
	
	      return this.setTabIndex(0);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          onBlur = _props.onBlur,
	          onKeyDown = _props.onKeyDown,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "className", "onBlur", "onKeyDown"]);
	      return _react.default.createElement(_List.default, (0, _extends2.default)({
	        role: "menu",
	        ref: function ref(node) {
	          _this2.list = node;
	        },
	        className: className,
	        onKeyDown: this.handleKeyDown,
	        onBlur: this.handleBlur
	      }, other), _react.default.Children.map(children, function (child, index) {
	        if (!_react.default.isValidElement(child)) {
	          return null;
	        }
	
	        return _react.default.cloneElement(child, {
	          tabIndex: index === _this2.state.currentTabIndex ? 0 : -1,
	          ref: child.props.selected ? function (node) {
	            _this2.selectedItem = node;
	          } : undefined,
	          onFocus: _this2.handleItemFocus
	        });
	      }));
	    }
	  }]);
	  return MenuList;
	}(_react.default.Component);
	
	MenuList.propTypes =  false ? {
	  /**
	   * MenuList contents, normally `MenuItem`s.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func
	} : {};
	var _default = MenuList;
	exports.default = _default;

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MenuList.default;
	  }
	});
	
	var _MenuList = _interopRequireDefault(__webpack_require__(252));

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(24));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _warning = _interopRequireDefault(__webpack_require__(14));
	
	var _keycode = _interopRequireDefault(__webpack_require__(58));
	
	var _activeElement = _interopRequireDefault(__webpack_require__(190));
	
	var _contains = _interopRequireDefault(__webpack_require__(74));
	
	var _inDOM = _interopRequireDefault(__webpack_require__(75));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(33));
	
	var _RootRef = _interopRequireDefault(__webpack_require__(166));
	
	var _Portal = _interopRequireDefault(__webpack_require__(164));
	
	var _helpers = __webpack_require__(35);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _ModalManager = _interopRequireDefault(__webpack_require__(83));
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(157));
	
	// @inheritedComponent Portal
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom.default.findDOMNode(container) || defaultContainer;
	}
	
	function getHasTransition(props) {
	  return props.children ? props.children.props.hasOwnProperty('in') : false;
	}
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      width: '100%',
	      height: '100%',
	      position: 'fixed',
	      zIndex: theme.zIndex.modal,
	      top: 0,
	      left: 0
	    },
	    hidden: {
	      visibility: 'hidden'
	    }
	  };
	};
	
	exports.styles = styles;
	
	var Modal =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Modal, _React$Component);
	  (0, _createClass2.default)(Modal, null, [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if (nextProps.open) {
	        return {
	          exited: false
	        };
	      } else if (!getHasTransition(nextProps)) {
	        // Otherwise let handleExited take care of marking exited.
	        return {
	          exited: true
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  function Modal(props, context) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Modal);
	    _this = (0, _possibleConstructorReturn2.default)(this, (Modal.__proto__ || (0, _getPrototypeOf.default)(Modal)).call(this, props, context));
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "dialogElement", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "mounted", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: false
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "mountNode", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleRendered", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        _this.autoFocus();
	
	        if (_this.props.onRendered) {
	          _this.props.onRendered();
	        }
	      }
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleOpen", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        var doc = (0, _ownerDocument.default)(_this.mountNode);
	        var container = getContainer(_this.props.container, doc.body);
	
	        _this.props.manager.add((0, _assertThisInitialized2.default)(_this), container);
	
	        doc.addEventListener('keydown', _this.handleDocumentKeyDown);
	        doc.addEventListener('focus', _this.enforceFocus, true);
	      }
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleClose", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        _this.props.manager.remove((0, _assertThisInitialized2.default)(_this));
	
	        var doc = (0, _ownerDocument.default)(_this.mountNode);
	        doc.removeEventListener('keydown', _this.handleDocumentKeyDown);
	        doc.removeEventListener('focus', _this.enforceFocus);
	
	        _this.restoreLastFocus();
	      }
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleExited", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        _this.setState({
	          exited: true
	        });
	
	        _this.handleClose();
	      }
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleBackdropClick", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        if (event.target !== event.currentTarget) {
	          return;
	        }
	
	        if (_this.props.onBackdropClick) {
	          _this.props.onBackdropClick(event);
	        }
	
	        if (!_this.props.disableBackdropClick && _this.props.onClose) {
	          _this.props.onClose(event, 'backdropClick');
	        }
	      }
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleDocumentKeyDown", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        if (!_this.isTopModal() || (0, _keycode.default)(event) !== 'esc') {
	          return;
	        }
	
	        if (_this.props.onEscapeKeyDown) {
	          _this.props.onEscapeKeyDown(event);
	        }
	
	        if (!_this.props.disableEscapeKeyDown && _this.props.onClose) {
	          _this.props.onClose(event, 'escapeKeyDown');
	        }
	      }
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "checkForFocus", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        if (_inDOM.default) {
	          _this.lastFocus = (0, _activeElement.default)();
	        }
	      }
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "enforceFocus", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        if (_this.props.disableEnforceFocus || !_this.mounted || !_this.isTopModal()) {
	          return;
	        }
	
	        var currentActiveElement = (0, _activeElement.default)((0, _ownerDocument.default)(_this.mountNode));
	
	        if (_this.dialogElement && !(0, _contains.default)(_this.dialogElement, currentActiveElement)) {
	          _this.dialogElement.focus();
	        }
	      }
	    });
	    _this.state = {
	      exited: !_this.props.open
	    };
	    return _this;
	  }
	
	  (0, _createClass2.default)(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	
	      if (this.props.open) {
	        this.handleOpen();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (!prevProps.open && this.props.open) {
	        this.checkForFocus();
	      }
	
	      if (prevProps.open && !this.props.open && !getHasTransition(this.props)) {
	        // Otherwise handleExited will call this.
	        this.handleClose();
	      } else if (!prevProps.open && this.props.open) {
	        this.handleOpen();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	
	      if (this.props.open || getHasTransition(this.props) && !this.state.exited) {
	        this.handleClose();
	      }
	    }
	  }, {
	    key: "autoFocus",
	    value: function autoFocus() {
	      if (this.props.disableAutoFocus) {
	        return;
	      }
	
	      var currentActiveElement = (0, _activeElement.default)((0, _ownerDocument.default)(this.mountNode));
	
	      if (this.dialogElement && !(0, _contains.default)(this.dialogElement, currentActiveElement)) {
	        this.lastFocus = currentActiveElement;
	
	        if (!this.dialogElement.hasAttribute('tabIndex')) {
	           false ? (0, _warning.default)(false, ['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n')) : void 0;
	          this.dialogElement.setAttribute('tabIndex', -1);
	        }
	
	        this.dialogElement.focus();
	      }
	    }
	  }, {
	    key: "restoreLastFocus",
	    value: function restoreLastFocus() {
	      if (this.props.disableRestoreFocus) {
	        return;
	      }
	
	      if (this.lastFocus) {
	        // Not all elements in IE11 have a focus method.
	        // Because IE11 market share is low, we accept the restore focus being broken
	        // and we silent the issue.
	        if (this.lastFocus.focus) {
	          this.lastFocus.focus();
	        }
	
	        this.lastFocus = null;
	      }
	    }
	  }, {
	    key: "isTopModal",
	    value: function isTopModal() {
	      return this.props.manager.isTopModal(this);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          BackdropComponent = _props.BackdropComponent,
	          BackdropProps = _props.BackdropProps,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          container = _props.container,
	          disableAutoFocus = _props.disableAutoFocus,
	          disableBackdropClick = _props.disableBackdropClick,
	          disableEnforceFocus = _props.disableEnforceFocus,
	          disableEscapeKeyDown = _props.disableEscapeKeyDown,
	          disableRestoreFocus = _props.disableRestoreFocus,
	          hideBackdrop = _props.hideBackdrop,
	          keepMounted = _props.keepMounted,
	          onBackdropClick = _props.onBackdropClick,
	          onClose = _props.onClose,
	          onEscapeKeyDown = _props.onEscapeKeyDown,
	          onRendered = _props.onRendered,
	          open = _props.open,
	          manager = _props.manager,
	          other = (0, _objectWithoutProperties2.default)(_props, ["BackdropComponent", "BackdropProps", "children", "classes", "className", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disableRestoreFocus", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open", "manager"]);
	      var exited = this.state.exited;
	      var hasTransition = getHasTransition(this.props);
	      var childProps = {};
	
	      if (!keepMounted && !open && (!hasTransition || exited)) {
	        return null;
	      } // It's a Transition like component
	
	
	      if (hasTransition) {
	        childProps.onExited = (0, _helpers.createChainedFunction)(this.handleExited, children.props.onExited);
	      }
	
	      if (children.props.role === undefined) {
	        childProps.role = children.props.role || 'document';
	      }
	
	      if (children.props.tabIndex === undefined) {
	        childProps.tabIndex = children.props.tabIndex || '-1';
	      }
	
	      return _react.default.createElement(_Portal.default, {
	        ref: function ref(node) {
	          _this2.mountNode = node ? node.getMountNode() : node;
	        },
	        container: container,
	        onRendered: this.handleRendered
	      }, _react.default.createElement("div", (0, _extends2.default)({
	        className: (0, _classnames.default)(classes.root, className, (0, _defineProperty2.default)({}, classes.hidden, exited))
	      }, other), hideBackdrop ? null : _react.default.createElement(BackdropComponent, (0, _extends2.default)({
	        open: open,
	        onClick: this.handleBackdropClick
	      }, BackdropProps)), _react.default.createElement(_RootRef.default, {
	        rootRef: function rootRef(node) {
	          _this2.dialogElement = node;
	        }
	      }, _react.default.cloneElement(children, childProps))));
	    }
	  }]);
	  return Modal;
	}(_react.default.Component);
	
	Modal.propTypes =  false ? {
	  /**
	   * A backdrop component. This property enables custom backdrop rendering.
	   */
	  BackdropComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Properties applied to the `Backdrop` element.
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   */
	  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	
	  /**
	   * If `true`, the modal will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, clicking the backdrop will not fire any callback.
	   */
	  disableBackdropClick: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not prevent focus from leaving the modal while open.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire any callback.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not restore focus to previously focused element once
	   * modal is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is not rendered.
	   */
	  hideBackdrop: _propTypes.default.bool,
	
	  /**
	   * Always keep the children in the DOM.
	   * This property can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Modal.
	   */
	  keepMounted: _propTypes.default.bool,
	
	  /**
	   * A modal manager used to track and manage the state of open
	   * Modals. This enables customizing how modals interact within a container.
	   */
	  manager: _propTypes.default.object,
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * The `reason` parameter can optionally be used to control the response to `onClose`.
	   *
	   * @param {object} event The event source of the callback
	   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableEscapeKeyDown` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes.default.func,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   * It signals that the `open={true}` property took effect.
	   */
	  onRendered: _propTypes.default.func,
	
	  /**
	   * If `true`, the modal is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : {};
	Modal.defaultProps = {
	  disableAutoFocus: false,
	  disableBackdropClick: false,
	  disableEnforceFocus: false,
	  disableEscapeKeyDown: false,
	  disableRestoreFocus: false,
	  hideBackdrop: false,
	  keepMounted: false,
	  // Modals don't open on the server so this won't conflict with concurrent requests.
	  manager: new _ModalManager.default(),
	  BackdropComponent: _Backdrop.default
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiModal'
	})(Modal);
	
	exports.default = _default;

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _keys = _interopRequireDefault(__webpack_require__(50));
	
	var _style = _interopRequireDefault(__webpack_require__(381));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(33));
	
	var _scrollbarSize = _interopRequireDefault(__webpack_require__(98));
	
	var _isOverflowing = _interopRequireDefault(__webpack_require__(161));
	
	var _manageAriaHidden = __webpack_require__(162);
	
	function findIndexOf(data, callback) {
	  var idx = -1;
	  data.some(function (item, index) {
	    if (callback(item)) {
	      idx = index;
	      return true;
	    }
	
	    return false;
	  });
	  return idx;
	}
	
	function getPaddingRight(node) {
	  return parseInt((0, _style.default)(node, 'paddingRight') || 0, 10);
	}
	
	function setContainerStyle(data, container) {
	  var style = {
	    overflow: 'hidden'
	  }; // We are only interested in the actual `style` here because we will override it.
	
	  data.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (data.overflowing) {
	    var scrollbarSize = (0, _scrollbarSize.default)(); // Use computed style, here to get the real padding to add our scrollbar width.
	
	    style.paddingRight = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
	
	    var fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');
	
	    for (var i = 0; i < fixedNodes.length; i += 1) {
	      var paddingRight = getPaddingRight(fixedNodes[i]);
	      data.prevPaddings.push(paddingRight);
	      fixedNodes[i].style.paddingRight = "".concat(paddingRight + scrollbarSize, "px");
	    }
	  }
	
	  (0, _keys.default)(style).forEach(function (key) {
	    container.style[key] = style[key];
	  });
	}
	
	function removeContainerStyle(data, container) {
	  (0, _keys.default)(data.style).forEach(function (key) {
	    container.style[key] = data.style[key];
	  });
	  var fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');
	
	  for (var i = 0; i < fixedNodes.length; i += 1) {
	    fixedNodes[i].style.paddingRight = "".concat(data.prevPaddings[i], "px");
	  }
	}
	/**
	 * @ignore - do not document.
	 *
	 * Proper state managment for containers and the modals in those containers.
	 * Simplified, but inspired by react-overlay's ModalManager class
	 * Used by the Modal to ensure proper styling of containers.
	 */
	
	
	var ModalManager =
	/*#__PURE__*/
	function () {
	  function ModalManager() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck2.default)(this, ModalManager);
	    var _options$hideSiblingN = options.hideSiblingNodes,
	        hideSiblingNodes = _options$hideSiblingN === void 0 ? true : _options$hideSiblingN,
	        _options$handleContai = options.handleContainerOverflow,
	        handleContainerOverflow = _options$handleContai === void 0 ? true : _options$handleContai;
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.handleContainerOverflow = handleContainerOverflow; // this.modals[modalIdx] = modal
	
	    this.modals = []; // this.containers[containerIdx] = container
	
	    this.containers = []; // this.data[containerIdx] = {
	    //   modals: [],
	    // }
	
	    this.data = [];
	  }
	
	  (0, _createClass2.default)(ModalManager, [{
	    key: "add",
	    value: function add(modal, container) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx !== -1) {
	        return modalIdx;
	      }
	
	      modalIdx = this.modals.length;
	      this.modals.push(modal);
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	      }
	
	      var containerIdx = this.containers.indexOf(container);
	
	      if (containerIdx !== -1) {
	        this.data[containerIdx].modals.push(modal);
	        return modalIdx;
	      }
	
	      var data = {
	        modals: [modal],
	        overflowing: (0, _isOverflowing.default)(container),
	        prevPaddings: []
	      };
	
	      if (this.handleContainerOverflow) {
	        setContainerStyle(data, container);
	      }
	
	      this.containers.push(container);
	      this.data.push(data);
	      return modalIdx;
	    }
	  }, {
	    key: "remove",
	    value: function remove(modal) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx === -1) {
	        return modalIdx;
	      }
	
	      var containerIdx = findIndexOf(this.data, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var data = this.data[containerIdx];
	      var container = this.containers[containerIdx];
	      data.modals.splice(data.modals.indexOf(modal), 1);
	      this.modals.splice(modalIdx, 1); // If that was the last modal in a container, clean up the container.
	
	      if (data.modals.length === 0) {
	        if (this.handleContainerOverflow) {
	          removeContainerStyle(data, container);
	        }
	
	        if (this.hideSiblingNodes) {
	          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	        }
	
	        this.containers.splice(containerIdx, 1);
	        this.data.splice(containerIdx, 1);
	      } else if (this.hideSiblingNodes) {
	        // Otherwise make sure the next top modal is visible to a screan reader.
	        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	      }
	
	      return modalIdx;
	    }
	  }, {
	    key: "isTopModal",
	    value: function isTopModal(modal) {
	      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	  return ModalManager;
	}();
	
	var _default = ModalManager;
	exports.default = _default;

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "ModalManager", {
	  enumerable: true,
	  get: function get() {
	    return _ModalManager.default;
	  }
	});
	
	var _Modal = _interopRequireDefault(__webpack_require__(160));
	
	var _ModalManager = _interopRequireDefault(__webpack_require__(83));

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isBody = isBody;
	exports.default = isOverflowing;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(224));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(33));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(84));
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	} // Do we have a scroll bar?
	
	
	function isOverflowing(container) {
	  var doc = (0, _ownerDocument.default)(container);
	  var win = (0, _ownerWindow.default)(doc);
	  /* istanbul ignore next */
	
	  if (!(0, _isWindow.default)(doc) && !isBody(container)) {
	    return container.scrollHeight > container.clientHeight;
	  } // Takes in account potential non zero margin on the body.
	
	
	  var style = win.getComputedStyle(doc.body);
	  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
	  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);
	  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
	}

/***/ }),

/***/ 162:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	var BLACKLIST = ['template', 'script', 'style'];
	
	function isHidable(node) {
	  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
	}
	
	function siblings(container, mount, callback) {
	  mount = [].concat(mount); // eslint-disable-line no-param-reassign
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      callback(node);
	    }
	  });
	}
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(24));
	
	var _warning = _interopRequireDefault(__webpack_require__(14));
	
	var _contains = _interopRequireDefault(__webpack_require__(74));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(33));
	
	var _debounce = _interopRequireDefault(__webpack_require__(124));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(93));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(84));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _Modal = _interopRequireDefault(__webpack_require__(129));
	
	var _Grow = _interopRequireDefault(__webpack_require__(245));
	
	var _Paper = _interopRequireDefault(__webpack_require__(78));
	
	// @inheritedComponent Modal
	function getOffsetTop(rect, vertical) {
	  var offset = 0;
	
	  if (typeof vertical === 'number') {
	    offset = vertical;
	  } else if (vertical === 'center') {
	    offset = rect.height / 2;
	  } else if (vertical === 'bottom') {
	    offset = rect.height;
	  }
	
	  return offset;
	}
	
	function getOffsetLeft(rect, horizontal) {
	  var offset = 0;
	
	  if (typeof horizontal === 'number') {
	    offset = horizontal;
	  } else if (horizontal === 'center') {
	    offset = rect.width / 2;
	  } else if (horizontal === 'right') {
	    offset = rect.width;
	  }
	
	  return offset;
	}
	
	function getTransformOriginValue(transformOrigin) {
	  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
	    return typeof n === 'number' ? "".concat(n, "px") : n;
	  }).join(' ');
	} // Sum the scrollTop between two elements.
	
	
	function getScrollParent(parent, child) {
	  var element = child;
	  var scrollTop = 0;
	
	  while (element && element !== parent) {
	    element = element.parentNode;
	    scrollTop += element.scrollTop;
	  }
	
	  return scrollTop;
	}
	
	function getAnchorEl(anchorEl) {
	  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
	}
	
	var styles = {
	  paper: {
	    position: 'absolute',
	    overflowY: 'auto',
	    overflowX: 'hidden',
	    // So we see the popover when it's empty.
	    // It's most likely on issue on userland.
	    minWidth: 16,
	    minHeight: 16,
	    maxWidth: 'calc(100vw - 32px)',
	    maxHeight: 'calc(100vh - 32px)',
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 'none'
	  }
	};
	exports.styles = styles;
	
	var Popover =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Popover, _React$Component);
	
	  function Popover() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Popover);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Popover.__proto__ || (0, _getPrototypeOf.default)(Popover)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "componentWillUnmount", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        _this.handleResize.cancel();
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "setPositioningStyles", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(element) {
	        if (element && element.style) {
	          var positioning = _this.getPositioningStyle(element);
	
	          if (positioning.top !== null) {
	            element.style.top = positioning.top;
	          }
	
	          if (positioning.left !== null) {
	            element.style.left = positioning.left;
	          }
	
	          element.style.transformOrigin = positioning.transformOrigin;
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "getPositioningStyle", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(element) {
	        var _this$props = _this.props,
	            anchorEl = _this$props.anchorEl,
	            anchorReference = _this$props.anchorReference,
	            marginThreshold = _this$props.marginThreshold; // Check if the parent has requested anchoring on an inner content node
	
	        var contentAnchorOffset = _this.getContentAnchorOffset(element);
	
	        var elemRect = {
	          width: element.clientWidth,
	          height: element.clientHeight
	        }; // Get the transform origin point on the element itself
	
	        var transformOrigin = _this.getTransformOrigin(elemRect, contentAnchorOffset);
	
	        if (anchorReference === 'none') {
	          return {
	            top: null,
	            left: null,
	            transformOrigin: getTransformOriginValue(transformOrigin)
	          };
	        } // Get the offset of of the anchoring element
	
	
	        var anchorOffset = _this.getAnchorOffset(contentAnchorOffset); // Calculate element positioning
	
	
	        var top = anchorOffset.top - transformOrigin.vertical;
	        var left = anchorOffset.left - transformOrigin.horizontal;
	        var bottom = top + elemRect.height;
	        var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
	
	        var containerWindow = (0, _ownerWindow.default)(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
	
	        var heightThreshold = containerWindow.innerHeight - marginThreshold;
	        var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
	
	        if (top < marginThreshold) {
	          var diff = top - marginThreshold;
	          top -= diff;
	          transformOrigin.vertical += diff;
	        } else if (bottom > heightThreshold) {
	          var _diff = bottom - heightThreshold;
	
	          top -= _diff;
	          transformOrigin.vertical += _diff;
	        }
	
	         false ? (0, _warning.default)(elemRect.height < heightThreshold || !elemRect.height || !heightThreshold, ['Material-UI: the popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n')) : void 0; // Check if the horizontal axis needs shifting
	
	        if (left < marginThreshold) {
	          var _diff2 = left - marginThreshold;
	
	          left -= _diff2;
	          transformOrigin.horizontal += _diff2;
	        } else if (right > widthThreshold) {
	          var _diff3 = right - widthThreshold;
	
	          left -= _diff3;
	          transformOrigin.horizontal += _diff3;
	        }
	
	        return {
	          top: "".concat(top, "px"),
	          left: "".concat(left, "px"),
	          transformOrigin: getTransformOriginValue(transformOrigin)
	        };
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "transitionEl", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: undefined
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleGetOffsetTop", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: getOffsetTop
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleGetOffsetLeft", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: getOffsetLeft
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleEnter", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(element) {
	        if (_this.props.onEnter) {
	          _this.props.onEnter(element);
	        }
	
	        _this.setPositioningStyles(element);
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleResize", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: (0, _debounce.default)(function () {
	        var element = _reactDom.default.findDOMNode(_this.transitionEl);
	
	        _this.setPositioningStyles(element);
	      }, 166)
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(Popover, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.action) {
	        this.props.action({
	          updatePosition: this.handleResize
	        });
	      }
	    }
	  }, {
	    key: "getAnchorOffset",
	    // Returns the top/left offset of the position
	    // to attach to on the anchor element (or body if none is provided)
	    value: function getAnchorOffset(contentAnchorOffset) {
	      var _props = this.props,
	          anchorEl = _props.anchorEl,
	          anchorOrigin = _props.anchorOrigin,
	          anchorReference = _props.anchorReference,
	          anchorPosition = _props.anchorPosition;
	
	      if (anchorReference === 'anchorPosition') {
	         false ? (0, _warning.default)(anchorPosition, 'Material-UI: you need to provide a `anchorPosition` property when using ' + '<Popover anchorReference="anchorPosition" />.') : void 0;
	        return anchorPosition;
	      } // If an anchor element wasn't provided, just use the parent body element of this Popover
	
	
	      var anchorElement = getAnchorEl(anchorEl) || (0, _ownerDocument.default)(_reactDom.default.findDOMNode(this.transitionEl)).body;
	      var anchorRect = anchorElement.getBoundingClientRect();
	      var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
	      return {
	        top: anchorRect.top + this.handleGetOffsetTop(anchorRect, anchorVertical),
	        left: anchorRect.left + this.handleGetOffsetLeft(anchorRect, anchorOrigin.horizontal)
	      };
	    } // Returns the vertical offset of inner content to anchor the transform on if provided
	
	  }, {
	    key: "getContentAnchorOffset",
	    value: function getContentAnchorOffset(element) {
	      var _props2 = this.props,
	          getContentAnchorEl = _props2.getContentAnchorEl,
	          anchorReference = _props2.anchorReference;
	      var contentAnchorOffset = 0;
	
	      if (getContentAnchorEl && anchorReference === 'anchorEl') {
	        var contentAnchorEl = getContentAnchorEl(element);
	
	        if (contentAnchorEl && (0, _contains.default)(element, contentAnchorEl)) {
	          var scrollTop = getScrollParent(element, contentAnchorEl);
	          contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
	        } // != the default value
	
	
	         false ? (0, _warning.default)(this.props.anchorOrigin.vertical === 'top', ['Material-UI: you can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` property to the popover component.', 'Only use one of the two properties.', 'Set `getContentAnchorEl` to null or left `anchorOrigin.vertical` unchanged.'].join('\n')) : void 0;
	      }
	
	      return contentAnchorOffset;
	    } // Return the base transform origin using the element
	    // and taking the content anchor offset into account if in use
	
	  }, {
	    key: "getTransformOrigin",
	    value: function getTransformOrigin(elemRect) {
	      var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var transformOrigin = this.props.transformOrigin;
	      return {
	        vertical: this.handleGetOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
	        horizontal: this.handleGetOffsetLeft(elemRect, transformOrigin.horizontal)
	      };
	    }
	  }, {
	    key: "render",
	    // Corresponds to 10 frames at 60 Hz.
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          action = _props3.action,
	          anchorEl = _props3.anchorEl,
	          anchorOrigin = _props3.anchorOrigin,
	          anchorPosition = _props3.anchorPosition,
	          anchorReference = _props3.anchorReference,
	          children = _props3.children,
	          classes = _props3.classes,
	          containerProp = _props3.container,
	          elevation = _props3.elevation,
	          getContentAnchorEl = _props3.getContentAnchorEl,
	          marginThreshold = _props3.marginThreshold,
	          onEnter = _props3.onEnter,
	          onEntered = _props3.onEntered,
	          onEntering = _props3.onEntering,
	          onExit = _props3.onExit,
	          onExited = _props3.onExited,
	          onExiting = _props3.onExiting,
	          open = _props3.open,
	          PaperProps = _props3.PaperProps,
	          role = _props3.role,
	          transformOrigin = _props3.transformOrigin,
	          TransitionComponent = _props3.TransitionComponent,
	          transitionDuration = _props3.transitionDuration,
	          TransitionProps = _props3.TransitionProps,
	          other = (0, _objectWithoutProperties2.default)(_props3, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "role", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]); // If the container prop is provided, use that
	      // If the anchorEl prop is provided, use its parent body element as the container
	      // If neither are provided let the Modal take care of choosing the container
	
	      var container = containerProp || (anchorEl ? (0, _ownerDocument.default)(getAnchorEl(anchorEl)).body : undefined);
	      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
	        container: container,
	        open: open,
	        BackdropProps: {
	          invisible: true
	        }
	      }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
	        appear: true,
	        "in": open,
	        onEnter: this.handleEnter,
	        onEntered: onEntered,
	        onEntering: onEntering,
	        onExit: onExit,
	        onExited: onExited,
	        onExiting: onExiting,
	        role: role,
	        ref: function ref(node) {
	          _this2.transitionEl = node;
	        }
	      }, TransitionProps), _react.default.createElement(_Paper.default, (0, _extends2.default)({
	        className: classes.paper,
	        elevation: elevation
	      }, PaperProps), _react.default.createElement(_reactEventListener.default, {
	        target: "window",
	        onResize: this.handleResize
	      }), children)));
	    }
	  }]);
	  return Popover;
	}(_react.default.Component);
	
	Popover.propTypes =  false ? {
	  /**
	   * This is callback property. It's called by the component on mount.
	   * This is useful when you want to trigger an action programmatically.
	   * It currently only supports updatePosition() action.
	   *
	   * @param {object} actions This object contains all posible actions
	   * that can be triggered programmatically.
	   */
	  action: _propTypes.default.func,
	
	  /**
	   * This is the DOM element, or a function that returns the DOM element,
	   * that may be used to set the position of the popover.
	   */
	  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	
	  /**
	   * This is the point on the anchor where the popover's
	   * `anchorEl` will attach to. This is not used when the
	   * anchorReference is 'anchorPosition'.
	   *
	   * Options:
	   * vertical: [top, center, bottom];
	   * horizontal: [left, center, right].
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]),
	    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])])
	  }),
	
	  /**
	   * This is the position that may be used
	   * to set the position of the popover.
	   * The coordinates are relative to
	   * the application's client area.
	   */
	  anchorPosition: _propTypes.default.shape({
	    top: _propTypes.default.number,
	    left: _propTypes.default.number
	  }),
	
	  /*
	   * This determines which anchor prop to refer to to set
	   * the position of the popover.
	   */
	  anchorReference: _propTypes.default.oneOf(['anchorEl', 'anchorPosition', 'none']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will passed to the Modal component.
	   * By default, it uses the body of the anchorEl's top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	
	  /**
	   * The elevation of the popover.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * This function is called in order to retrieve the content anchor element.
	   * It's the opposite of the `anchorEl` property.
	   * The content anchor element should be an element inside the popover.
	   * It's used to correctly scroll and set the position of the popover.
	   * The positioning strategy tries to make the content anchor element just above the
	   * anchor element.
	   */
	  getContentAnchorEl: _propTypes.default.func,
	
	  /**
	   * Specifies how close to the edge of the window the popover can appear.
	   */
	  marginThreshold: _propTypes.default.number,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component is entering.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component is exiting.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the popover is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * Properties applied to the `Paper` element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * This is the point on the popover which
	   * will attach to the anchor's origin.
	   *
	   * Options:
	   * vertical: [top, center, bottom, x(px)];
	   * horizontal: [left, center, right, x(px)].
	   */
	  transformOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]),
	    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])])
	  }),
	
	  /**
	   * Transition component.
	   */
	  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  }), _propTypes.default.oneOf(['auto'])]),
	
	  /**
	   * Properties applied to the `Transition` element.
	   */
	  TransitionProps: _propTypes.default.object
	} : {};
	Popover.defaultProps = {
	  anchorReference: 'anchorEl',
	  anchorOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  elevation: 8,
	  marginThreshold: 16,
	  transformOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  TransitionComponent: _Grow.default,
	  transitionDuration: 'auto'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPopover'
	})(Popover);
	
	exports.default = _default;

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Popover.default;
	  }
	});
	
	var _Popover = _interopRequireDefault(__webpack_require__(254));

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(24));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(33));
	
	var _exactProp = _interopRequireDefault(__webpack_require__(211));
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom.default.findDOMNode(container) || defaultContainer;
	}
	
	function getOwnerDocument(element) {
	  return (0, _ownerDocument.default)(_reactDom.default.findDOMNode(element));
	}
	/**
	 * This component shares many concepts with
	 * [react-overlays](https://react-bootstrap.github.io/react-overlays/#portals)
	 * But has been forked in order to fix some bugs, reduce the number of dependencies
	 * and take the control of our destiny.
	 */
	
	
	var Portal =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Portal, _React$Component);
	
	  function Portal() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Portal);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Portal.__proto__ || (0, _getPrototypeOf.default)(Portal)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "getMountNode", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        return _this.mountNode;
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(Portal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setContainer(this.props.container);
	      this.forceUpdate(this.props.onRendered);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.container !== this.props.container) {
	        this.setContainer(this.props.container);
	        this.forceUpdate();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mountNode = null;
	    }
	  }, {
	    key: "setContainer",
	    value: function setContainer(container) {
	      this.mountNode = getContainer(container, getOwnerDocument(this).body);
	    }
	    /**
	     * @public
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      return this.mountNode ? _reactDom.default.createPortal(children, this.mountNode) : null;
	    }
	  }]);
	  return Portal;
	}(_react.default.Component);
	
	Portal.propTypes =  false ? {
	  /**
	   * The children to render into the `container`.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   */
	  onRendered: _propTypes.default.func
	} : {};
	Portal.propTypes =  false ? (0, _exactProp.default)(Portal.propTypes, 'Portal') : {};
	var _default = Portal;
	exports.default = _default;

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Portal.default;
	  }
	});
	
	var _Portal = _interopRequireDefault(__webpack_require__(163));

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(24));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	/**
	 * Helper component to allow attaching a ref to a
	 * child element that may not accept refs (functional component).
	 * It's higly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801
	 */
	var RootRef =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(RootRef, _React$Component);
	
	  function RootRef() {
	    (0, _classCallCheck2.default)(this, RootRef);
	    return (0, _possibleConstructorReturn2.default)(this, (RootRef.__proto__ || (0, _getPrototypeOf.default)(RootRef)).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(RootRef, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.rootRef(_reactDom.default.findDOMNode(this));
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.props.rootRef(null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return RootRef;
	}(_react.default.Component);
	
	RootRef.propTypes =  false ? {
	  children: _propTypes.default.element.isRequired,
	  rootRef: _propTypes.default.func.isRequired
	} : {};
	var _default = RootRef;
	exports.default = _default;

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _RootRef.default;
	  }
	});
	
	var _RootRef = _interopRequireDefault(__webpack_require__(165));

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(19));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _SelectInput = _interopRequireDefault(__webpack_require__(257));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(263));
	
	var _Input = _interopRequireDefault(__webpack_require__(67));
	
	// @inheritedComponent Input
	// Import to enforce the CSS injection order
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      width: '100%'
	    },
	    select: {
	      '-moz-appearance': 'none',
	      // Reset
	      '-webkit-appearance': 'none',
	      // Reset
	      // When interacting quickly, the text can end up selected.
	      // Native select can't be selected either.
	      userSelect: 'none',
	      paddingRight: theme.spacing.unit * 4,
	      width: "calc(100% - ".concat(theme.spacing.unit * 4, "px)"),
	      minWidth: theme.spacing.unit * 2,
	      // So it doesn't collapse.
	      cursor: 'pointer',
	      '&:focus': {
	        // Show that it's not an text input
	        background: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
	        borderRadius: 0 // Reset Chrome style
	
	      },
	      // Remove Firefox focus border
	      '&:-moz-focusring': {
	        color: 'transparent',
	        textShadow: '0 0 0 #000'
	      },
	      // Remove IE11 arrow
	      '&::-ms-expand': {
	        display: 'none'
	      },
	      '&$disabled': {
	        cursor: 'default'
	      }
	    },
	    selectMenu: {
	      width: 'auto',
	      // Fix Safari textOverflow
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      minHeight: '1.1875em' // Reset (19px), match the native input line-height
	
	    },
	    disabled: {},
	    icon: {
	      // We use a position absolute over a flexbox in order to forward the pointer events
	      // to the input.
	      position: 'absolute',
	      right: 0,
	      top: 'calc(50% - 12px)',
	      // Center vertically
	      color: theme.palette.action.active,
	      'pointer-events': 'none' // Don't block pointer events on the select under the icon.
	
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Select(props) {
	  var autoWidth = props.autoWidth,
	      children = props.children,
	      classes = props.classes,
	      displayEmpty = props.displayEmpty,
	      IconComponent = props.IconComponent,
	      input = props.input,
	      inputProps = props.inputProps,
	      MenuProps = props.MenuProps,
	      multiple = props.multiple,
	      native = props.native,
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      open = props.open,
	      renderValue = props.renderValue,
	      SelectDisplayProps = props.SelectDisplayProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "input", "inputProps", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps"]);
	  return _react.default.cloneElement(input, (0, _objectSpread2.default)({
	    // Most of the logic is implemented in `SelectInput`.
	    // The `Select` component is a simple API wrapper to expose something better to play with.
	    inputComponent: _SelectInput.default,
	    inputProps: (0, _objectSpread2.default)({
	      autoWidth: autoWidth,
	      children: children,
	      classes: classes,
	      displayEmpty: displayEmpty,
	      IconComponent: IconComponent,
	      MenuProps: MenuProps,
	      multiple: multiple,
	      native: native,
	      onClose: onClose,
	      onOpen: onOpen,
	      open: open,
	      renderValue: renderValue,
	      SelectDisplayProps: SelectDisplayProps,
	      type: undefined
	    }, inputProps, input ? input.props.inputProps : {})
	  }, other));
	}
	
	Select.propTypes =  false ? {
	  /**
	   * If true, the width of the popover will automatically be set according to the items inside the
	   * menu, otherwise it will be at least the width of the select input.
	   */
	  autoWidth: _propTypes.default.bool,
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * If `true`, the selected item is displayed even if its value is empty.
	   * You can only use it when the `native` property is `false` (default).
	   */
	  displayEmpty: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * An `Input` element; does not have to be a material-ui specific `Input`.
	   */
	  input: _propTypes.default.element,
	
	  /**
	   * Properties applied to the `input` element.
	   * When `native` is `true`, the properties are applied on the `select` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Properties applied to the `Menu` element.
	   */
	  MenuProps: _propTypes.default.object,
	
	  /**
	   * If true, `value` must be an array and the menu will support multiple selections.
	   * You can only use it when the `native` property is `false` (default).
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will be using a native `select` element.
	   */
	  native: _propTypes.default.bool,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value`.
	   * @param {object} [child] The react element that was selected when `native` is `false` (default).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control `select` open state.
	   * You can only use it when the `native` property is `false` (default).
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Render the selected value.
	   * You can only use it when the `native` property is `false` (default).
	   *
	   * @param {*} value The `value` provided to the component.
	   * @returns {ReactElement}
	   */
	  renderValue: _propTypes.default.func,
	
	  /**
	   * Properties applied to the clickable div element.
	   */
	  SelectDisplayProps: _propTypes.default.object,
	
	  /**
	   * The input value.
	   * This property is required when the `native` property is `false` (default).
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))])
	} : {};
	Select.defaultProps = {
	  autoWidth: false,
	  displayEmpty: false,
	  IconComponent: _ArrowDropDown.default,
	  input: _react.default.createElement(_Input.default, null),
	  multiple: false,
	  native: false
	};
	Select.muiName = 'Select';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSelect'
	})(Select);
	
	exports.default = _default;

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(19));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(82));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _keycode = _interopRequireDefault(__webpack_require__(58));
	
	var _warning = _interopRequireDefault(__webpack_require__(14));
	
	var _Menu = _interopRequireDefault(__webpack_require__(251));
	
	var _Input = __webpack_require__(104);
	
	/**
	 * @ignore - internal component.
	 */
	var SelectInput =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(SelectInput, _React$Component);
	
	  function SelectInput() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, SelectInput);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = SelectInput.__proto__ || (0, _getPrototypeOf.default)(SelectInput)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "state", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: {
	        open: false
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "ignoreNextBlur", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: false
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "displayNode", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "displayWidth", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "isOpenControlled", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: _this.props.open !== undefined
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "isControlled", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: _this.props.value != null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "updateDisplayWidth", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        // Perfom the layout computation outside of the render method.
	        if (_this.displayNode) {
	          _this.displayWidth = _this.displayNode.clientWidth;
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "update", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: _this.isOpenControlled ? function (_ref2) {
	        var event = _ref2.event,
	            open = _ref2.open;
	
	        if (open) {
	          _this.props.onOpen(event);
	        } else {
	          _this.props.onClose(event);
	        }
	      } : function (_ref3) {
	        var open = _ref3.open;
	        return _this.setState({
	          open: open
	        });
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleClick", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        // Opening the menu is going to blur the. It will be focused back when closed.
	        _this.ignoreNextBlur = true;
	
	        _this.update({
	          open: true,
	          event: event
	        });
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleClose", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        _this.update({
	          open: false,
	          event: event
	        });
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleItemClick", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(child) {
	        return function (event) {
	          if (!_this.props.multiple) {
	            _this.update({
	              open: false,
	              event: event
	            });
	          }
	
	          var _this$props = _this.props,
	              onChange = _this$props.onChange,
	              name = _this$props.name;
	
	          if (onChange) {
	            var value;
	            var target;
	
	            if (event.target) {
	              target = event.target;
	            }
	
	            if (_this.props.multiple) {
	              value = Array.isArray(_this.props.value) ? (0, _toConsumableArray2.default)(_this.props.value) : [];
	              var itemIndex = value.indexOf(child.props.value);
	
	              if (itemIndex === -1) {
	                value.push(child.props.value);
	              } else {
	                value.splice(itemIndex, 1);
	              }
	            } else {
	              value = child.props.value;
	            }
	
	            event.persist();
	            event.target = (0, _objectSpread2.default)({}, target, {
	              value: value,
	              name: name
	            });
	            onChange(event, child);
	          }
	        };
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleBlur", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        if (_this.ignoreNextBlur === true) {
	          // The parent components are relying on the bubbling of the event.
	          event.stopPropagation();
	          _this.ignoreNextBlur = false;
	          return;
	        }
	
	        if (_this.props.onBlur) {
	          _this.props.onBlur(event);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleKeyDown", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        if (_this.props.readOnly) {
	          return;
	        }
	
	        if (['space', 'up', 'down'].indexOf((0, _keycode.default)(event)) !== -1) {
	          event.preventDefault(); // Opening the menu is going to blur the. It will be focused back when closed.
	
	          _this.ignoreNextBlur = true;
	
	          _this.update({
	            open: true,
	            event: event
	          });
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleDisplayRef", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        _this.displayNode = node;
	
	        _this.updateDisplayWidth();
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleSelectRef", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        if (!_this.props.inputRef) {
	          return;
	        }
	
	        _this.props.inputRef({
	          node: node,
	          // By pass the native input as we expose a rich object (array).
	          value: _this.props.value
	        });
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(SelectInput, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.isOpenControlled && this.props.open) {
	        // Focus the display node so the focus is restored on this element once
	        // the menu is closed.
	        this.displayNode.focus(); // Rerender with the resolve `displayNode` reference.
	
	        this.forceUpdate();
	      }
	
	      if (this.props.autoFocus && !this.props.native) {
	        this.displayNode.focus();
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate() {
	      this.updateDisplayWidth();
	      return true;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          children = _props.children,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          disabled = _props.disabled,
	          displayEmpty = _props.displayEmpty,
	          IconComponent = _props.IconComponent,
	          inputRef = _props.inputRef,
	          _props$MenuProps = _props.MenuProps,
	          MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
	          multiple = _props.multiple,
	          name = _props.name,
	          native = _props.native,
	          onBlur = _props.onBlur,
	          onChange = _props.onChange,
	          onClose = _props.onClose,
	          onFocus = _props.onFocus,
	          onOpen = _props.onOpen,
	          openProp = _props.open,
	          readOnly = _props.readOnly,
	          renderValue = _props.renderValue,
	          SelectDisplayProps = _props.SelectDisplayProps,
	          tabIndexProp = _props.tabIndex,
	          _props$type = _props.type,
	          type = _props$type === void 0 ? 'hidden' : _props$type,
	          value = _props.value,
	          other = (0, _objectWithoutProperties2.default)(_props, ["autoWidth", "children", "classes", "className", "disabled", "displayEmpty", "IconComponent", "inputRef", "MenuProps", "multiple", "name", "native", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value"]);
	      var open = this.isOpenControlled && this.displayNode ? openProp : this.state.open;
	
	      if (native) {
	         false ? (0, _warning.default)(multiple === false, 'Material-UI: you can not use the `native={true}` and `multiple={true}` properties ' + 'at the same time on a `Select` component.') : void 0;
	         false ? (0, _warning.default)(!renderValue, 'Material-UI: the `renderValue` property is not used by the native implementation.') : void 0;
	         false ? (0, _warning.default)(!displayEmpty, 'Material-UI: the `displayEmpty` property is not used by the native implementation.') : void 0;
	        return _react.default.createElement("div", {
	          className: classes.root
	        }, _react.default.createElement("select", (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.select, (0, _defineProperty2.default)({}, classes.disabled, disabled), classNameProp),
	          name: name,
	          disabled: disabled,
	          onBlur: onBlur,
	          onChange: onChange,
	          onFocus: onFocus,
	          value: value,
	          readOnly: readOnly,
	          ref: inputRef
	        }, other), children), _react.default.createElement(IconComponent, {
	          className: classes.icon
	        }));
	      }
	
	      if (!this.isControlled) {
	        throw new Error('Material-UI: the `value` property is required ' + 'when using the `Select` component with `native=false` (default).');
	      }
	
	      var display;
	      var displaySingle = '';
	      var displayMultiple = [];
	      var computeDisplay = false; // No need to display any value if the field is empty.
	
	      if ((0, _Input.isFilled)(this.props) || displayEmpty) {
	        if (renderValue) {
	          display = renderValue(value);
	        } else {
	          computeDisplay = true;
	        }
	      }
	
	      var items = _react.default.Children.map(children, function (child) {
	        if (!_react.default.isValidElement(child)) {
	          return null;
	        }
	
	        var selected;
	
	        if (multiple) {
	          if (!Array.isArray(value)) {
	            throw new Error('Material-UI: the `value` property must be an array ' + 'when using the `Select` component with `multiple`.');
	          }
	
	          selected = value.indexOf(child.props.value) !== -1;
	
	          if (selected && computeDisplay) {
	            displayMultiple.push(child.props.children);
	          }
	        } else {
	          selected = value === child.props.value;
	
	          if (selected && computeDisplay) {
	            displaySingle = child.props.children;
	          }
	        }
	
	        return _react.default.cloneElement(child, {
	          onClick: _this2.handleItemClick(child),
	          role: 'option',
	          selected: selected,
	          value: undefined,
	          // The value is most likely not a valid HTML attribute.
	          'data-value': child.props.value // Instead, we provide it as a data attribute.
	
	        });
	      });
	
	      if (computeDisplay) {
	        display = multiple ? displayMultiple.join(', ') : displaySingle;
	      }
	
	      var MenuMinWidth = this.displayNode && !autoWidth ? this.displayWidth : undefined;
	      var tabIndex;
	
	      if (typeof tabIndexProp !== 'undefined') {
	        tabIndex = tabIndexProp;
	      } else {
	        tabIndex = disabled ? null : 0;
	      }
	
	      return _react.default.createElement("div", {
	        className: classes.root
	      }, _react.default.createElement("div", (0, _extends2.default)({
	        className: (0, _classnames.default)(classes.select, classes.selectMenu, (0, _defineProperty2.default)({}, classes.disabled, disabled), classNameProp),
	        ref: this.handleDisplayRef,
	        "aria-pressed": open ? 'true' : 'false',
	        tabIndex: tabIndex,
	        role: "button",
	        "aria-owns": open ? "menu-".concat(name || '') : null,
	        "aria-haspopup": "true",
	        onKeyDown: this.handleKeyDown,
	        onBlur: this.handleBlur,
	        onClick: disabled || readOnly ? null : this.handleClick,
	        onFocus: onFocus
	      }, SelectDisplayProps), display || _react.default.createElement("span", {
	        dangerouslySetInnerHTML: {
	          __html: '&#8203'
	        }
	      })), _react.default.createElement("input", (0, _extends2.default)({
	        value: Array.isArray(value) ? value.join(',') : value,
	        name: name,
	        readOnly: readOnly,
	        ref: this.handleSelectRef,
	        type: type
	      }, other)), _react.default.createElement(IconComponent, {
	        className: classes.icon
	      }), _react.default.createElement(_Menu.default, (0, _extends2.default)({
	        id: "menu-".concat(name || ''),
	        anchorEl: this.displayNode,
	        open: open,
	        onClose: this.handleClose
	      }, MenuProps, {
	        MenuListProps: (0, _objectSpread2.default)({
	          role: 'listbox'
	        }, MenuProps.MenuListProps),
	        PaperProps: (0, _objectSpread2.default)({}, MenuProps.PaperProps, {
	          style: (0, _objectSpread2.default)({
	            minWidth: MenuMinWidth
	          }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
	        })
	      }), items));
	    }
	  }]);
	  return SelectInput;
	}(_react.default.Component);
	
	SelectInput.propTypes =  false ? {
	  /**
	   * @ignore
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If true, the width of the popover will automatically be set according to the items inside the
	   * menu, otherwise it will be at least the width of the select input.
	   */
	  autoWidth: _propTypes.default.bool,
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the select element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the select will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the selected item is displayed even if its value is empty.
	   * You can only use it when the `native` property is `false` (default).
	   */
	  displayEmpty: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Use that property to pass a ref callback to the native select element.
	   */
	  inputRef: _propTypes.default.func,
	
	  /**
	   * Properties applied to the `Menu` element.
	   */
	  MenuProps: _propTypes.default.object,
	
	  /**
	   * If true, `value` must be an array and the menu will support multiple selections.
	   * You can only use it when the `native` property is `false` (default).
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `select` or hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * If `true`, the component will be using a native `select` element.
	   */
	  native: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value`.
	   * @param {object} [child] The react element that was selected when `native` is `false` (default).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control `select` open state.
	   * You can only use it when the `native` property is `false` (default).
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * Render the selected value.
	   * You can only use it when the `native` property is `false` (default).
	   *
	   * @param {*} value The `value` provided to the component.
	   * @returns {ReactElement}
	   */
	  renderValue: _propTypes.default.func,
	
	  /**
	   * Properties applied to the clickable div element.
	   */
	  SelectDisplayProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The input value.
	   * This property is required when the `native` property is `false` (default).
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))])
	} : {};
	var _default = SelectInput;
	exports.default = _default;

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	
	var _Select = _interopRequireDefault(__webpack_require__(256));

/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTranslateValue = setTranslateValue;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(19));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(24));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(93));
	
	var _debounce = _interopRequireDefault(__webpack_require__(124));
	
	var _Transition = _interopRequireDefault(__webpack_require__(103));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(84));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(130));
	
	var _transitions = __webpack_require__(105);
	
	var _utils = __webpack_require__(167);
	
	// @inheritedComponent Transition
	var GUTTER = 24; // Translate the node so he can't be seen on the screen.
	// Later, we gonna translate back the node to his original location
	// with `translate3d(0, 0, 0)`.`
	
	function getTranslateValue(props, node) {
	  var direction = props.direction;
	  var rect = node.getBoundingClientRect();
	  var transform;
	
	  if (node.fakeTransform) {
	    transform = node.fakeTransform;
	  } else {
	    var computedStyle = (0, _ownerWindow.default)(node).getComputedStyle(node);
	    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
	  }
	
	  var offsetX = 0;
	  var offsetY = 0;
	
	  if (transform && transform !== 'none' && typeof transform === 'string') {
	    var transformValues = transform.split('(')[1].split(')')[0].split(',');
	    offsetX = parseInt(transformValues[4], 10);
	    offsetY = parseInt(transformValues[5], 10);
	  }
	
	  if (direction === 'left') {
	    return "translateX(100vw) translateX(-".concat(rect.left - offsetX, "px)");
	  } else if (direction === 'right') {
	    return "translateX(-".concat(rect.left + rect.width + GUTTER - offsetX, "px)");
	  } else if (direction === 'up') {
	    return "translateY(100vh) translateY(-".concat(rect.top - offsetY, "px)");
	  } // direction === 'down'
	
	
	  return "translateY(-".concat(rect.top + rect.height + GUTTER - offsetY, "px)");
	}
	
	function setTranslateValue(props, node) {
	  var transform = getTranslateValue(props, node);
	
	  if (transform) {
	    node.style.webkitTransform = transform;
	    node.style.transform = transform;
	  }
	}
	/**
	 * The Slide transition is used by the [Snackbar](/demos/snackbars) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	
	var Slide =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Slide, _React$Component);
	
	  function Slide() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Slide);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Slide.__proto__ || (0, _getPrototypeOf.default)(Slide)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "mounted", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: false
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "transition", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleResize", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: (0, _debounce.default)(function () {
	        // Skip configuration where the position is screen size invariant.
	        if (_this.props.in || _this.props.direction === 'down' || _this.props.direction === 'right') {
	          return;
	        }
	
	        var node = _reactDom.default.findDOMNode(_this.transition);
	
	        if (node) {
	          setTranslateValue(_this.props, node);
	        }
	      }, 166)
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleEnter", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        setTranslateValue(_this.props, node);
	        (0, _utils.reflow)(node);
	
	        if (_this.props.onEnter) {
	          _this.props.onEnter(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleEntering", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        var theme = _this.props.theme;
	        var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
	          mode: 'enter'
	        });
	        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _objectSpread2.default)({}, transitionProps, {
	          easing: theme.transitions.easing.easeOut
	        }));
	        node.style.transition = theme.transitions.create('transform', (0, _objectSpread2.default)({}, transitionProps, {
	          easing: theme.transitions.easing.easeOut
	        }));
	        node.style.webkitTransform = 'translate(0, 0)';
	        node.style.transform = 'translate(0, 0)';
	
	        if (_this.props.onEntering) {
	          _this.props.onEntering(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleExit", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        var theme = _this.props.theme;
	        var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
	          mode: 'exit'
	        });
	        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _objectSpread2.default)({}, transitionProps, {
	          easing: theme.transitions.easing.sharp
	        }));
	        node.style.transition = theme.transitions.create('transform', (0, _objectSpread2.default)({}, transitionProps, {
	          easing: theme.transitions.easing.sharp
	        }));
	        setTranslateValue(_this.props, node);
	
	        if (_this.props.onExit) {
	          _this.props.onExit(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleExited", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        // No need for transitions when the component is hidden
	        node.style.webkitTransition = '';
	        node.style.transition = '';
	
	        if (_this.props.onExited) {
	          _this.props.onExited(node);
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(Slide, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // state.mounted handle SSR, once the component is mounted, we need
	      // to properly hide it.
	      if (!this.props.in) {
	        // We need to set initial translate values of transition element
	        // otherwise component will be shown when in=false.
	        this.updatePosition();
	      }
	
	      this.mounted = true;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.direction !== this.props.direction && !this.props.in) {
	        // We need to update the position of the drawer when the direction change and
	        // when it's hidden.
	        this.updatePosition();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	    }
	  }, {
	    key: "updatePosition",
	    value: function updatePosition() {
	      var node = _reactDom.default.findDOMNode(this.transition);
	
	      if (node) {
	        node.style.visibility = 'inherit';
	        setTranslateValue(this.props, node);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          onEnter = _props.onEnter,
	          onEntering = _props.onEntering,
	          onExit = _props.onExit,
	          onExited = _props.onExited,
	          styleProp = _props.style,
	          theme = _props.theme,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "onEnter", "onEntering", "onExit", "onExited", "style", "theme"]);
	      var style = {}; // We use this state to handle the server-side rendering.
	      // We don't know the width of the children ahead of time.
	      // We need to render it.
	
	      if (!this.props.in && !this.mounted) {
	        style.visibility = 'hidden';
	      }
	
	      style = (0, _objectSpread2.default)({}, style, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
	      return _react.default.createElement(_reactEventListener.default, {
	        target: "window",
	        onResize: this.handleResize
	      }, _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        onEnter: this.handleEnter,
	        onEntering: this.handleEntering,
	        onExit: this.handleExit,
	        onExited: this.handleExited,
	        appear: true,
	        style: style,
	        ref: function ref(node) {
	          _this2.transition = node;
	        }
	      }, other), children));
	    }
	  }]);
	  return Slide;
	}(_react.default.Component);
	
	Slide.propTypes =  false ? {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
	
	  /**
	   * Direction the child node will enter from.
	   */
	  direction: _propTypes.default.oneOf(['left', 'right', 'up', 'down']),
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : {};
	Slide.defaultProps = {
	  direction: 'down',
	  timeout: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  }
	};
	
	var _default = (0, _withTheme.default)()(Slide);
	
	exports.default = _default;

/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	
	var _Slide = _interopRequireDefault(__webpack_require__(878));

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectSpread8 = _interopRequireDefault(__webpack_require__(19));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(93));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _transitions = __webpack_require__(105);
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(866));
	
	var _helpers = __webpack_require__(35);
	
	var _Slide = _interopRequireDefault(__webpack_require__(769));
	
	var _SnackbarContent = _interopRequireDefault(__webpack_require__(882));
	
	var styles = function styles(theme) {
	  var gutter = theme.spacing.unit * 3;
	  var top = {
	    top: 0
	  };
	  var bottom = {
	    bottom: 0
	  };
	  var right = {
	    justifyContent: 'flex-end'
	  };
	  var left = {
	    justifyContent: 'flex-start'
	  };
	  var topSpace = {
	    top: gutter
	  };
	  var bottomSpace = {
	    bottom: gutter
	  };
	  var rightSpace = {
	    right: gutter
	  };
	  var leftSpace = {
	    left: gutter
	  };
	  var center = {
	    left: '50%',
	    right: 'auto',
	    transform: 'translateX(-50%)'
	  };
	  return {
	    root: {
	      zIndex: theme.zIndex.snackbar,
	      position: 'fixed',
	      display: 'flex',
	      left: 0,
	      right: 0,
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	    anchorOriginTopCenter: (0, _objectSpread8.default)({}, top, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({}, center))),
	    anchorOriginBottomCenter: (0, _objectSpread8.default)({}, bottom, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({}, center))),
	    anchorOriginTopRight: (0, _objectSpread8.default)({}, top, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({
	      left: 'auto'
	    }, topSpace, rightSpace))),
	    anchorOriginBottomRight: (0, _objectSpread8.default)({}, bottom, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({
	      left: 'auto'
	    }, bottomSpace, rightSpace))),
	    anchorOriginTopLeft: (0, _objectSpread8.default)({}, top, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({
	      right: 'auto'
	    }, topSpace, leftSpace))),
	    anchorOriginBottomLeft: (0, _objectSpread8.default)({}, bottom, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({
	      right: 'auto'
	    }, bottomSpace, leftSpace)))
	  };
	};
	
	exports.styles = styles;
	
	var Snackbar =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Snackbar, _React$Component);
	
	  function Snackbar() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Snackbar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf.default)(Snackbar)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "state", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: {}
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "timerAutoHide", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleMouseEnter", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        if (_this.props.onMouseEnter) {
	          _this.props.onMouseEnter(event);
	        }
	
	        _this.handlePause();
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleMouseLeave", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        if (_this.props.onMouseLeave) {
	          _this.props.onMouseLeave(event);
	        }
	
	        _this.handleResume();
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleClickAway", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        if (_this.props.onClose) {
	          _this.props.onClose(event, 'clickaway');
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handlePause", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        clearTimeout(_this.timerAutoHide);
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleResume", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        if (_this.props.autoHideDuration != null) {
	          if (_this.props.resumeHideDuration !== undefined) {
	            _this.setAutoHideTimer(_this.props.resumeHideDuration);
	
	            return;
	          }
	
	          _this.setAutoHideTimer((_this.props.autoHideDuration || 0) * 0.5);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleExited", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        _this.setState({
	          exited: true
	        });
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(Snackbar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.open) {
	        this.setAutoHideTimer();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.open !== this.props.open) {
	        if (this.props.open) {
	          this.setAutoHideTimer();
	        } else {
	          clearTimeout(this.timerAutoHide);
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerAutoHide);
	    } // Timer that controls delay before snackbar auto hides
	
	  }, {
	    key: "setAutoHideTimer",
	    value: function setAutoHideTimer() {
	      var _this2 = this;
	
	      var autoHideDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      if (!this.props.onClose || this.props.autoHideDuration == null) {
	        return;
	      }
	
	      clearTimeout(this.timerAutoHide);
	      this.timerAutoHide = setTimeout(function () {
	        if (!_this2.props.onClose || _this2.props.autoHideDuration == null) {
	          return;
	        }
	
	        _this2.props.onClose(null, 'timeout');
	      }, autoHideDuration || this.props.autoHideDuration || 0);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          action = _props.action,
	          _props$anchorOrigin = _props.anchorOrigin,
	          vertical = _props$anchorOrigin.vertical,
	          horizontal = _props$anchorOrigin.horizontal,
	          autoHideDuration = _props.autoHideDuration,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          ContentProps = _props.ContentProps,
	          disableWindowBlurListener = _props.disableWindowBlurListener,
	          message = _props.message,
	          onClose = _props.onClose,
	          onEnter = _props.onEnter,
	          onEntered = _props.onEntered,
	          onEntering = _props.onEntering,
	          onExit = _props.onExit,
	          onExited = _props.onExited,
	          onExiting = _props.onExiting,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          open = _props.open,
	          resumeHideDuration = _props.resumeHideDuration,
	          TransitionComponent = _props.TransitionComponent,
	          transitionDuration = _props.transitionDuration,
	          TransitionProps = _props.TransitionProps,
	          other = (0, _objectWithoutProperties2.default)(_props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]); // So we only render active snackbars.
	
	      if (!open && this.state.exited) {
	        return null;
	      }
	
	      return _react.default.createElement(_ClickAwayListener.default, {
	        onClickAway: this.handleClickAway
	      }, _react.default.createElement("div", (0, _extends2.default)({
	        className: (0, _classnames.default)(classes.root, classes["anchorOrigin".concat((0, _helpers.capitalize)(vertical)).concat((0, _helpers.capitalize)(horizontal))], className),
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave
	      }, other), _react.default.createElement(_reactEventListener.default, {
	        target: "window",
	        onFocus: disableWindowBlurListener ? undefined : this.handleResume,
	        onBlur: disableWindowBlurListener ? undefined : this.handlePause
	      }), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
	        appear: true,
	        "in": open,
	        onEnter: onEnter,
	        onEntered: onEntered,
	        onEntering: onEntering,
	        onExit: onExit,
	        onExited: (0, _helpers.createChainedFunction)(this.handleExited, onExited),
	        onExiting: onExiting,
	        timeout: transitionDuration,
	        direction: vertical === 'top' ? 'down' : 'up'
	      }, TransitionProps), children || _react.default.createElement(_SnackbarContent.default, (0, _extends2.default)({
	        message: message,
	        action: action
	      }, ContentProps)))));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (typeof prevState.exited === 'undefined') {
	        return {
	          exited: !nextProps.open
	        };
	      }
	
	      if (nextProps.open) {
	        return {
	          exited: false
	        };
	      }
	
	      return null;
	    }
	  }]);
	  return Snackbar;
	}(_react.default.Component);
	
	Snackbar.propTypes =  false ? {
	  /**
	   * The action to display.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * The anchor of the `Snackbar`.
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]),
	    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])])
	  }),
	
	  /**
	   * The number of milliseconds to wait before automatically calling the
	   * `onClose` function. `onClose` should then set the state of the `open`
	   * prop to hide the Snackbar. This behavior is disabled by default with
	   * the `null` value.
	   */
	  autoHideDuration: _propTypes.default.number,
	
	  /**
	   * If you wish the take control over the children of the component you can use this property.
	   * When used, you replace the `SnackbarContent` component with the children.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Properties applied to the `SnackbarContent` element.
	   */
	  ContentProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
	   */
	  disableWindowBlurListener: _propTypes.default.bool,
	
	  /**
	   * When displaying multiple consecutive Snackbars from a parent rendering a single
	   * <Snackbar/>, add the key property to ensure independent treatment of each message.
	   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
	   * features such as autoHideDuration may be canceled.
	   */
	  key: _propTypes.default.any,
	
	  /**
	   * The message to display.
	   */
	  message: _propTypes.default.node,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Typically `onClose` is used to set state in the parent component,
	   * which is used to control the `Snackbar` `open` prop.
	   * The `reason` parameter can optionally be used to control the response to `onClose`,
	   * for example ignoring `clickaway`.
	   *
	   * @param {object} event The event source of the callback
	   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the transition is entering.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the transition is exiting.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * If true, `Snackbar` is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before dismissing after user interaction.
	   * If `autoHideDuration` property isn't specified, it does nothing.
	   * If `autoHideDuration` property is specified but `resumeHideDuration` isn't,
	   * we default to `autoHideDuration / 2` ms.
	   */
	  resumeHideDuration: _propTypes.default.number,
	
	  /**
	   * Transition component.
	   */
	  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Properties applied to the `Transition` element.
	   */
	  TransitionProps: _propTypes.default.object
	} : {};
	Snackbar.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'center'
	  },
	  disableWindowBlurListener: false,
	  TransitionComponent: _Slide.default,
	  transitionDuration: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  }
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiSnackbar'
	})(Snackbar);
	
	exports.default = _default;

/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Snackbar.default;
	  }
	});
	
	var _Snackbar = _interopRequireDefault(__webpack_require__(879));

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _Paper = _interopRequireDefault(__webpack_require__(78));
	
	var _Typography = _interopRequireDefault(__webpack_require__(11));
	
	var _colorManipulator = __webpack_require__(55);
	
	// @inheritedComponent Paper
	var styles = function styles(theme) {
	  var _root;
	
	  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
	  var backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);
	  return {
	    root: (_root = {
	      pointerEvents: 'initial',
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      display: 'flex',
	      alignItems: 'center',
	      flexWrap: 'wrap',
	      padding: "6px ".concat(theme.spacing.unit * 3, "px")
	    }, (0, _defineProperty2.default)(_root, theme.breakpoints.up('md'), {
	      minWidth: 288,
	      maxWidth: 568,
	      borderRadius: 2
	    }), (0, _defineProperty2.default)(_root, theme.breakpoints.down('sm'), {
	      flexGrow: 1
	    }), _root),
	    message: {
	      padding: "".concat(theme.spacing.unit, "px 0")
	    },
	    action: {
	      display: 'flex',
	      alignItems: 'center',
	      marginLeft: 'auto',
	      paddingLeft: theme.spacing.unit * 3,
	      marginRight: -theme.spacing.unit
	    }
	  };
	};
	
	exports.styles = styles;
	
	function SnackbarContent(props) {
	  var action = props.action,
	      classes = props.classes,
	      className = props.className,
	      message = props.message,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "classes", "className", "message"]);
	  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    component: _Typography.default,
	    headlineMapping: {
	      body1: 'div'
	    },
	    role: "alertdialog",
	    square: true,
	    elevation: 6,
	    className: (0, _classnames.default)(classes.root, className)
	  }, other), _react.default.createElement("div", {
	    className: classes.message
	  }, message), action ? _react.default.createElement("div", {
	    className: classes.action
	  }, action) : null);
	}
	
	SnackbarContent.propTypes =  false ? {
	  /**
	   * The action to display.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The message to display.
	   */
	  message: _propTypes.default.node
	} : {};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSnackbarContent'
	})(SnackbarContent);
	
	exports.default = _default;

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SnackbarContent.default;
	  }
	});
	
	var _SnackbarContent = _interopRequireDefault(__webpack_require__(881));

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _warning = _interopRequireDefault(__webpack_require__(14));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Input = _interopRequireDefault(__webpack_require__(67));
	
	var _InputLabel = _interopRequireDefault(__webpack_require__(249));
	
	var _FormControl = _interopRequireDefault(__webpack_require__(240));
	
	var _FormHelperText = _interopRequireDefault(__webpack_require__(241));
	
	var _Select = _interopRequireDefault(__webpack_require__(258));
	
	// @inheritedComponent FormControl
	
	/**
	 * The `TextField` is a convenience wrapper for the most common cases (80%).
	 * It cannot be all things to all people, otherwise the API would grow out of control.
	 *
	 * ## Advanced Configuration
	 *
	 * It's important to understand that the text field is a simple abstraction
	 * on top of the following components:
	 * - [FormControl](/api/form-control)
	 * - [InputLabel](/api/input-label)
	 * - [Input](/api/input)
	 * - [FormHelperText](/api/form-helper-text)
	 *
	 * If you wish to alter the properties applied to the native input, you can do as follow:
	 *
	 * ```jsx
	 * const inputProps = {
	 *   step: 300,
	 * };
	 *
	 * return <TextField id="time" type="time" inputProps={inputProps} />;
	 * ```
	 *
	 * For advanced cases, please look at the source of TextField by clicking on the
	 * "Edit this page" button above. Consider either:
	 * - using the upper case props for passing values direct to the components.
	 * - using the underlying components directly as shown in the demos.
	 */
	function TextField(props) {
	  var autoComplete = props.autoComplete,
	      autoFocus = props.autoFocus,
	      children = props.children,
	      className = props.className,
	      defaultValue = props.defaultValue,
	      disabled = props.disabled,
	      error = props.error,
	      FormHelperTextProps = props.FormHelperTextProps,
	      fullWidth = props.fullWidth,
	      helperText = props.helperText,
	      id = props.id,
	      InputLabelProps = props.InputLabelProps,
	      inputProps = props.inputProps,
	      InputProps = props.InputProps,
	      inputRef = props.inputRef,
	      label = props.label,
	      multiline = props.multiline,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      placeholder = props.placeholder,
	      required = props.required,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      select = props.select,
	      SelectProps = props.SelectProps,
	      type = props.type,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoComplete", "autoFocus", "children", "className", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "select", "SelectProps", "type", "value"]);
	   false ? (0, _warning.default)(!select || Boolean(children), 'Material-UI: `children` must be passed when using the `TextField` component with `select`.') : void 0;
	  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
	
	  var InputElement = _react.default.createElement(_Input.default, (0, _extends2.default)({
	    autoComplete: autoComplete,
	    autoFocus: autoFocus,
	    defaultValue: defaultValue,
	    disabled: disabled,
	    fullWidth: fullWidth,
	    multiline: multiline,
	    name: name,
	    rows: rows,
	    rowsMax: rowsMax,
	    type: type,
	    value: value,
	    id: id,
	    inputRef: inputRef,
	    onBlur: onBlur,
	    onChange: onChange,
	    onFocus: onFocus,
	    placeholder: placeholder,
	    inputProps: inputProps
	  }, InputProps));
	
	  return _react.default.createElement(_FormControl.default, (0, _extends2.default)({
	    "aria-describedby": helperTextId,
	    className: className,
	    error: error,
	    fullWidth: fullWidth,
	    required: required
	  }, other), label && _react.default.createElement(_InputLabel.default, (0, _extends2.default)({
	    htmlFor: id
	  }, InputLabelProps), label), select ? _react.default.createElement(_Select.default, (0, _extends2.default)({
	    value: value,
	    input: InputElement
	  }, SelectProps), children) : InputElement, helperText && _react.default.createElement(_FormHelperText.default, (0, _extends2.default)({
	    id: helperTextId
	  }, FormHelperTextProps), helperText));
	}
	
	TextField.propTypes =  false ? {
	  /**
	   * This property helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it here:
	   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the input will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The default value of the `Input` element.
	   */
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * If `true`, the input will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * Properties applied to the `FormHelperText` element.
	   */
	  FormHelperTextProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The helper text content.
	   */
	  helperText: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   * Use that property to make `label` and `helperText` accessible for screen readers.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Properties applied to the `InputLabel` element.
	   */
	  InputLabelProps: _propTypes.default.object,
	
	  /**
	   * Properties applied to the `Input` element.
	   */
	  InputProps: _propTypes.default.object,
	
	  /**
	   * Properties applied to the native `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes.default.func,
	
	  /**
	   * The label content.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),
	
	  /**
	   * If `true`, a textarea element will be rendered instead of an input.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value`.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * If `true`, the label is displayed as required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	
	  /**
	   * Render a `Select` element while passing the `Input` element to `Select` as `input` parameter.
	   * If this option is set you must pass the options of the select as children.
	   */
	  select: _propTypes.default.bool,
	
	  /**
	   * Properties applied to the `Select` element.
	   */
	  SelectProps: _propTypes.default.object,
	
	  /**
	   * Type attribute of the `Input` element. It should be a valid HTML5 input type.
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `Input` element, required for a controlled component.
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))])
	} : {};
	TextField.defaultProps = {
	  required: false,
	  select: false
	};
	var _default = TextField;
	exports.default = _default;

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TextField.default;
	  }
	});
	
	var _TextField = _interopRequireDefault(__webpack_require__(259));

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _pure = _interopRequireDefault(__webpack_require__(49));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(364));
	
	var _ref = _react.default.createElement("path", {
	  d: "M7 10l5 5 5-5z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var ArrowDropDown = function ArrowDropDown(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	ArrowDropDown = (0, _pure.default)(ArrowDropDown);
	ArrowDropDown.muiName = 'SvgIcon';
	var _default = ArrowDropDown;
	exports.default = _default;

/***/ }),

/***/ 1073:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1074:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4049:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAngleRight = function FaAngleRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.3 21.4q0 0.3-0.2 0.5l-10.4 10.4q-0.3 0.3-0.6 0.3t-0.5-0.3l-1.1-1.1q-0.2-0.2-0.2-0.5t0.2-0.5l8.8-8.8-8.8-8.7q-0.2-0.3-0.2-0.6t0.2-0.5l1.1-1.1q0.3-0.2 0.5-0.2t0.6 0.2l10.4 10.4q0.2 0.2 0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaAngleRight;
	module.exports = exports['default'];

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFacebook = function FaFacebook(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.4 0.3v5.9h-3.5q-1.9 0-2.6 0.8t-0.7 2.4v4.2h6.6l-0.9 6.6h-5.7v16.9h-6.8v-16.9h-5.7v-6.6h5.7v-4.9q0-4.1 2.3-6.4t6.2-2.3q3.3 0 5.1 0.3z' })
	        )
	    );
	};
	
	exports.default = FaFacebook;
	module.exports = exports['default'];

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGooglePlus = function FaGooglePlus(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.2 20.3q0 3.6-1.6 6.5t-4.3 4.4-6.5 1.6q-2.6 0-5-1t-4.1-2.7-2.7-4.1-1-5 1-5 2.7-4.1 4.1-2.7 5-1q5 0 8.6 3.3l-3.5 3.4q-2-2-5.1-2-2.1 0-4 1.1t-2.8 2.9-1.1 4.1 1.1 4.1 2.8 2.9 4 1.1q1.5 0 2.7-0.4t2-1 1.4-1.4 0.8-1.4 0.4-1.3h-7.3v-4.4h12.1q0.3 1.1 0.3 2.1z m15.1-2.1v3.6h-3.6v3.7h-3.7v-3.7h-3.7v-3.6h3.7v-3.7h3.7v3.7h3.6z' })
	        )
	    );
	};
	
	exports.default = FaGooglePlus;
	module.exports = exports['default'];

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPinterestP = function FaPinterestP(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm5.5 13.3q0-2.4 0.8-4.5t2.3-3.7 3.4-2.8 4.2-1.7 4.5-0.6q3.5 0 6.5 1.5t5 4.3 1.9 6.4q0 2.2-0.5 4.2t-1.3 4-2.2 3.3-3.3 2.3-4.2 0.9q-1.5 0-3-0.8t-2.1-1.9q-0.3 0.8-0.7 2.5t-0.5 2.1-0.4 1.6-0.6 1.6-0.7 1.4-1.1 1.7-1.4 1.9l-0.3 0.1-0.2-0.2q-0.3-3.5-0.3-4.2 0-2 0.5-4.6t1.5-6.4 1.1-4.5q-0.7-1.5-0.7-3.8 0-1.9 1.2-3.5t2.9-1.6q1.4 0 2.1 0.9t0.8 2.3q0 1.5-1 4.2t-1 4.2q0 1.4 1 2.3t2.5 1q1.2 0 2.3-0.6t1.7-1.5 1.3-2.1 0.8-2.5 0.4-2.5 0.2-2.2q0-3.9-2.5-6t-6.3-2.2q-4.5 0-7.5 2.9t-3 7.4q0 0.9 0.3 1.9t0.6 1.4 0.6 1 0.3 0.7q0 0.6-0.3 1.6t-0.9 1q0 0-0.3 0-1.2-0.4-2.1-1.3t-1.3-2.1-0.8-2.4-0.2-2.4z' })
	        )
	    );
	};
	
	exports.default = FaPinterestP;
	module.exports = exports['default'];

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTwitter = function FaTwitter(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.7 9.1q-1.5 2.2-3.7 3.7 0.1 0.3 0.1 1 0 2.9-0.9 5.8t-2.6 5.5-4.1 4.7-5.7 3.3-7.2 1.2q-6.1 0-11.1-3.3 0.8 0.1 1.7 0.1 5 0 9-3-2.4-0.1-4.2-1.5t-2.6-3.5q0.8 0.1 1.4 0.1 1 0 1.9-0.3-2.5-0.5-4.1-2.5t-1.7-4.6v0q1.5 0.8 3.3 0.9-1.5-1-2.4-2.6t-0.8-3.4q0-2 0.9-3.7 2.7 3.4 6.6 5.4t8.3 2.2q-0.2-0.9-0.2-1.7 0-3 2.1-5.1t5.1-2.1q3.2 0 5.3 2.3 2.4-0.5 4.6-1.7-0.8 2.5-3.2 3.9 2.1-0.2 4.2-1.1z' })
	        )
	    );
	};
	
	exports.default = FaTwitter;
	module.exports = exports['default'];

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IoAndroidCheckmarkCircle = function IoAndroidCheckmarkCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.1 16.9l5 5 14-13.9 2.3 2.2-16.3 16.3-7.3-7.3z m19.6 3.1h3.3c0 8.9-7.3 16.3-16.2 16.3s-16.3-7.4-16.3-16.3 7.3-16.2 16.3-16.2c2.1 0 4.2 0.4 6 1.2l-2.5 2.5c-1.1-0.3-2.3-0.5-3.5-0.5-7.2 0-13 5.8-13 13s5.8 13 13 13 12.9-5.8 12.9-13z' })
	        )
	    );
	};
	
	exports.default = IoAndroidCheckmarkCircle;
	module.exports = exports['default'];

/***/ }),

/***/ 4054:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IoAndroidMenu = function IoAndroidMenu(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm5 30v-3.4h30v3.4h-30z m0-8.4v-3.2h30v3.2h-30z m0-11.6h30v3.4h-30v-3.4z' })
	        )
	    );
	};
	
	exports.default = IoAndroidMenu;
	module.exports = exports['default'];

/***/ }),

/***/ 4056:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IoSocialInstagramOutline = function IoSocialInstagramOutline(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35 8.8v22.5c0 2.1-1.7 3.7-3.7 3.7h-22.5c-2.1 0-3.8-1.6-3.8-3.7v-22.5c0-2.1 1.7-3.8 3.8-3.8h22.5c2 0 3.7 1.7 3.7 3.8z m-15 5c-3.4 0-6.2 2.8-6.2 6.2s2.8 6.3 6.2 6.3 6.3-2.9 6.3-6.3-2.9-6.2-6.3-6.2z m12.5-1.3v-3.7c0-0.8-0.5-1.3-1.2-1.3h-3.8c-0.7 0-1.2 0.5-1.2 1.3v3.7c0 0.7 0.5 1.3 1.2 1.3h3.8c0.7 0 1.2-0.6 1.2-1.3z m-1.2 20c0.7 0 1.2-0.5 1.2-1.2v-13.8h-4.1c0.3 0.8 0.4 1.6 0.4 2.5 0 2.3-0.9 4.5-2.5 6.2s-4 2.6-6.3 2.6-4.5-1-6.2-2.6-2.5-3.9-2.5-6.2c0-0.9 0.1-1.7 0.3-2.5h-4.1v13.8c0 0.7 0.6 1.2 1.3 1.2h22.5z' })
	        )
	    );
	};
	
	exports.default = IoSocialInstagramOutline;
	module.exports = exports['default'];

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IoSocialInstagram = function IoSocialInstagram(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.8 20c0-4.1 2.1-6.2 6.2-6.2s6.3 2.1 6.3 6.2-2.2 6.3-6.3 6.3-6.2-2.2-6.2-6.3z m0-6.2c-1.1 1.1-1.8 2.3-2.2 3.7h-6.6v-8.7c0-1.1 0.3-2 1.1-2.7s1.7-1.1 2.7-1.1h22.5c1 0 1.9 0.4 2.6 1.1s1.1 1.6 1.1 2.7v8.7h-6.6c-0.4-1.4-1.1-2.6-2.2-3.7-1.7-1.7-3.8-2.5-6.2-2.5s-4.5 0.8-6.2 2.5z m18.7-2.2v-3.1c0-0.3-0.2-0.5-0.3-0.7s-0.4-0.3-0.7-0.3h-3c-0.3 0-0.5 0.2-0.7 0.3s-0.3 0.4-0.3 0.7v3.1c0 0.3 0.2 0.5 0.3 0.7s0.4 0.2 0.7 0.2h3c0.3 0 0.5-0.1 0.7-0.2s0.3-0.4 0.3-0.7z m-6.2 14.6c1.7-1.7 2.5-3.8 2.5-6.2h6.2v11.3c0 1-0.4 1.8-1.1 2.6s-1.6 1.1-2.6 1.1h-22.5c-1 0-1.8-0.3-2.6-1.1s-1.2-1.6-1.2-2.6v-11.3h6.3c0 2.4 0.8 4.5 2.5 6.2s3.8 2.6 6.2 2.6 4.5-0.9 6.3-2.6z' })
	        )
	    );
	};
	
	exports.default = IoSocialInstagram;
	module.exports = exports['default'];

/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdArrowDropDown = function MdArrowDropDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.6 16.6h16.8l-8.4 8.4z' })
	        )
	    );
	};
	
	exports.default = MdArrowDropDown;
	module.exports = exports['default'];

/***/ }),

/***/ 1075:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1076:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1077:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 913:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Snackbar = __webpack_require__(880);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    container: {
	      boxShadow: 'none'
	    },
	    error: {
	      background: theme.palette.error.main
	    },
	    warning: {
	      background: theme.palette.warning
	    },
	    success: {
	      background: theme.palette.success
	    },
	    info: {
	      background: theme.palette.primary.main
	    }
	  };
	};
	
	var Alert = function Alert(_ref) {
	  var _cx;
	
	  var classes = _ref.classes,
	      alert = _ref.alert,
	      closeAlert = _ref.closeAlert;
	  return _react2.default.createElement(_Snackbar2.default, {
	    open: alert.open,
	    onClose: closeAlert,
	    anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
	    message: _react2.default.createElement(_Typography2.default, {
	      style: { color: '#fff' },
	      dangerouslySetInnerHTML: { __html: alert.message }
	    }),
	    key: alert.message,
	    autoHideDuration: 3500,
	    ContentProps: {
	      className: (0, _classnames2.default)(classes.container, (_cx = {}, _cx[classes.error] = alert.type === 'error', _cx[classes.warning] = alert.type === 'warning', _cx[classes.success] = alert.type === 'success', _cx[classes.info] = alert.type === 'info', _cx))
	    }
	  });
	};
	
	Alert.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  alert: _propTypes2.default.shape({
	    open: _propTypes2.default.bool.isRequired,
	    type: _propTypes2.default.string.isRequired,
	    message: _propTypes2.default.string
	  }).isRequired,
	  closeAlert: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _withStyles2.default)(styles, { withTheme: true })(Alert);
	module.exports = exports['default'];

/***/ }),

/***/ 919:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(49);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _withTheme = __webpack_require__(130);
	
	var _withTheme2 = _interopRequireDefault(_withTheme);
	
	var _pinterestP = __webpack_require__(149);
	
	var _pinterestP2 = _interopRequireDefault(_pinterestP);
	
	var _twitter = __webpack_require__(150);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _socialInstagram = __webpack_require__(346);
	
	var _socialInstagram2 = _interopRequireDefault(_socialInstagram);
	
	var _googlePlus = __webpack_require__(148);
	
	var _googlePlus2 = _interopRequireDefault(_googlePlus);
	
	var _facebook = __webpack_require__(147);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialIcon = function SocialIcon(_ref) {
	  var theme = _ref.theme,
	      Icon = _ref.Icon,
	      url = _ref.url,
	      title = _ref.title,
	      bright = _ref.bright;
	
	  if (!Icon) {
	    throw new Error('You must provide a social media icon.');
	  }
	  if (!url) {
	    throw new Error('Please provide a URL to redirect to.');
	  }
	
	  return _react2.default.createElement(
	    'a',
	    { href: url, target: '_blank', style: { margin: '0 4px' }, title: title },
	    _react2.default.createElement(Icon, {
	      style: {
	        color: bright ? '#fff' : theme.palette.primary.dark,
	        border: '1px solid ' + (bright ? '#fff' : theme.palette.primary.dark),
	        borderRadius: '50%',
	        padding: 5,
	        fontSize: '1.9em'
	      }
	    }),
	    _react2.default.createElement(
	      'style',
	      null,
	      '\n        a:hover {\n          opacity: 0.7;\n        }\n        '
	    )
	  );
	};
	SocialIcon.propTypes = {
	  Icon: _propTypes2.default.any.isRequired,
	  url: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  bright: _propTypes2.default.bool
	};
	
	var EnhancedSocialIcon = (0, _withTheme2.default)()((0, _pure2.default)(SocialIcon));
	
	var FollowBar = function FollowBar(_ref2) {
	  var height = _ref2.height,
	      bright = _ref2.bright;
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        height: height || 120,
	        width: '100%',
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center'
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      { style: { padding: 5 } },
	      _react2.default.createElement(
	        _Typography2.default,
	        {
	          align: 'center',
	          variant: 'title',
	          style: {
	            textTransform: 'uppercase',
	            marginBottom: 8,
	            fontWeight: 600,
	            color: bright && '#fff'
	          }
	        },
	        'Follow'
	      ),
	      _react2.default.createElement(EnhancedSocialIcon, {
	        Icon: _pinterestP2.default,
	        url: ("https://www.pinterest.com/healthfulinspired/"),
	        title: 'Pinterest',
	        bright: bright
	      }),
	      _react2.default.createElement(EnhancedSocialIcon, {
	        Icon: _facebook2.default,
	        url: ("https://www.facebook.com/healthfulinspired/"),
	        title: 'Facebook',
	        bright: bright
	      }),
	      _react2.default.createElement(EnhancedSocialIcon, {
	        Icon: _twitter2.default,
	        url: ("https://twitter.com/healthfulinspir/"),
	        title: 'Twitter',
	        bright: bright
	      }),
	      _react2.default.createElement(EnhancedSocialIcon, {
	        Icon: _socialInstagram2.default,
	        url: ("https://www.instagram.com/healthfulinspired/"),
	        title: 'Instagram',
	        bright: bright
	      }),
	      _react2.default.createElement(EnhancedSocialIcon, {
	        Icon: _googlePlus2.default,
	        url: ("https://plus.google.com/u/0/115535737505938510496/"),
	        title: 'Google Plus',
	        bright: bright
	      })
	    )
	  );
	};
	
	FollowBar.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  bright: _propTypes2.default.bool
	};
	
	exports.default = (0, _pure2.default)(FollowBar);
	module.exports = exports['default'];

/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Divider = __webpack_require__(212);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _SubscribeForm = __webpack_require__(959);
	
	var _SubscribeForm2 = _interopRequireDefault(_SubscribeForm);
	
	var _FollowBar = __webpack_require__(919);
	
	var _FollowBar2 = _interopRequireDefault(_FollowBar);
	
	var _Section = __webpack_require__(921);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _text, _blueLink;
	
	  return {
	    container: {
	      maxWidth: 1250,
	      margin: 'auto',
	      padding: 20
	    },
	    text: (_text = {
	      color: theme.palette.text.lighter
	    }, _text[theme.breakpoints.down('sm')] = {
	      fontSize: '0.8em'
	    }, _text),
	    blueLink: (_blueLink = {
	      fontWeight: 500,
	      color: '#09aafa'
	    }, _blueLink[theme.breakpoints.down('sm')] = {
	      fontSize: '0.8em'
	    }, _blueLink['&:hover'] = {
	      color: '#74e6ff'
	    }, _blueLink),
	    copyright: {
	      fontWeight: 300,
	      color: '#fff'
	    }
	  };
	};
	
	var Footer = function Footer(_ref) {
	  var classes = _ref.classes,
	      theme = _ref.theme;
	  return _react2.default.createElement(
	    'div',
	    { style: { background: theme.palette.primary.main } },
	    _react2.default.createElement(
	      'div',
	      { className: classes.container },
	      _react2.default.createElement(_FollowBar2.default, { height: 100, bright: true }),
	      _react2.default.createElement(_Divider2.default, {
	        offset: 25,
	        style: {
	          background: theme.palette.borders.ghost,
	          opacity: 0.3
	        }
	      }),
	      _react2.default.createElement(
	        _Grid2.default,
	        { spacing: 24, container: true },
	        _react2.default.createElement(_Section2.default, {
	          innerSections: [{
	            header: 'Change Your Life With Us',
	            body: _react2.default.createElement(
	              _Typography2.default,
	              {
	                component: _gatsbyLink2.default,
	                to: '/',
	                className: classes.blueLink,
	                gutterBottom: true,
	                paragraph: true
	              },
	              'healthfulinspired.com'
	            )
	          }, {
	            header: 'Find Inspiration',
	            body: _react2.default.createElement(
	              _Typography2.default,
	              {
	                component: _gatsbyLink2.default,
	                to: '/weight-loss-stories',
	                className: classes.blueLink,
	                gutterBottom: true,
	                paragraph: true
	              },
	              'WEIGHT LOSS STORIES'
	            )
	          }, {
	            header: 'Stay Physically Confident',
	            body: _react2.default.createElement(
	              _Typography2.default,
	              {
	                component: _gatsbyLink2.default,
	                to: '/weight-loss-workouts',
	                className: classes.blueLink,
	                gutterBottom: true,
	                paragraph: true
	              },
	              'WORKOUTS CURATED FOR WEIGHT LOSS'
	            )
	          }, {
	            header: 'Never Fall Behind',
	            body: _react2.default.createElement(
	              _Typography2.default,
	              {
	                component: _gatsbyLink2.default,
	                to: '/weight-loss-articles',
	                className: classes.blueLink,
	                gutterBottom: true,
	                paragraph: true
	              },
	              'WEIGHT LOSS ARTICLES, CONTENT AND TIPS'
	            )
	          }]
	        }),
	        _react2.default.createElement(_Section2.default, {
	          innerSections: [{
	            header: 'Subscribe',
	            body: _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _Typography2.default,
	                { className: classes.text },
	                'Become a subscriber today to start receiving newsletters of the latest, best trending health content delivered straight to your inbox. (You only need to enter your email)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { position: 'relative', minHeight: 170 } },
	                _react2.default.createElement(_SubscribeForm2.default, null)
	              )
	            )
	          }]
	        }),
	        _react2.default.createElement(_Section2.default, {
	          innerSections: [{
	            header: 'Amazon Associates Disclosure',
	            body: _react2.default.createElement(
	              _Typography2.default,
	              { className: classes.text, gutterBottom: true, paragraph: true },
	              'We are a participant in the Amazon Services LLC Associates Program, an affiliate advertising program designed to provide a means for us to earn fees by advertising linking to Amazon.com and affiliated sites.'
	            )
	          }, {
	            header: 'Privacy Policy',
	            body: _react2.default.createElement(
	              _Typography2.default,
	              {
	                component: _gatsbyLink2.default,
	                to: '/privacy-policy',
	                className: classes.blueLink,
	                gutterBottom: true,
	                paragraph: true
	              },
	              'Read our privacy policy'
	            )
	          }, {
	            body:
	            // eslint-disable-next-line
	            _react2.default.createElement(
	              _Typography2.default,
	              { className: classes.copyright, variant: 'caption' },
	              'Copyright \xA9 2018 Healthful&Inspired'
	            )
	          }]
	        })
	      )
	    )
	  );
	};
	
	Footer.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _withStyles2.default)(styles, { withTheme: true })(Footer);
	module.exports = exports['default'];

/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styles = function styles(theme) {
	  var _header;
	
	  return {
	    header: (_header = {
	      color: '#fff',
	      textTransform: 'uppercase'
	    }, _header[theme.breakpoints.down('sm')] = {
	      fontSize: '1em'
	    }, _header)
	  };
	};
	
	var Section = function Section(_ref) {
	  var classes = _ref.classes,
	      innerSections = _ref.innerSections,
	      props = _objectWithoutProperties(_ref, ['classes', 'innerSections']);
	
	  return _react2.default.createElement(
	    _Grid2.default,
	    _extends({}, props, { xs: 12, sm: 4, item: true }),
	    innerSections.map(function (_ref2, i) {
	      var header = _ref2.header,
	          body = _ref2.body;
	      return _react2.default.createElement(
	        'div',
	        { key: 'inner_section' + i },
	        _react2.default.createElement(
	          _Typography2.default,
	          { className: classes.header, variant: 'title', gutterBottom: true },
	          header
	        ),
	        body
	      );
	    })
	  );
	};
	
	Section.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  innerSections: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    body: _propTypes2.default.node.isRequired
	  })).isRequired
	};
	
	exports.default = (0, _withStyles2.default)(styles)(Section);
	module.exports = exports['default'];

/***/ }),

/***/ 778:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withTheme = __webpack_require__(130);
	
	var _withTheme2 = _interopRequireDefault(_withTheme);
	
	var _pure = __webpack_require__(49);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _pinterestP = __webpack_require__(149);
	
	var _pinterestP2 = _interopRequireDefault(_pinterestP);
	
	var _facebook = __webpack_require__(147);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _socialInstagramOutline = __webpack_require__(4056);
	
	var _socialInstagramOutline2 = _interopRequireDefault(_socialInstagramOutline);
	
	var _googlePlus = __webpack_require__(148);
	
	var _googlePlus2 = _interopRequireDefault(_googlePlus);
	
	var _twitter = __webpack_require__(150);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _startCase = __webpack_require__(339);
	
	var _startCase2 = _interopRequireDefault(_startCase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FollowBar = function FollowBar(_ref) {
	  var theme = _ref.theme,
	      dark = _ref.dark;
	
	  var socialMediaLinks = [{
	    type: 'pinterest',
	    url: ("https://www.pinterest.com/healthfulinspired/"),
	    color: theme.palette.social.pinterest,
	    Icon: _pinterestP2.default
	  }, {
	    type: 'facebook',
	    url: ("https://www.facebook.com/healthfulinspired/"),
	    color: theme.palette.social.facebook,
	    Icon: _facebook2.default
	  }, {
	    type: 'twitter',
	    url: ("https://twitter.com/healthfulinspir/"),
	    color: theme.palette.social.twitter,
	    Icon: _twitter2.default
	  }, {
	    type: 'instagram',
	    url: ("https://www.instagram.com/healthfulinspired/"),
	    color: theme.palette.social.instagram,
	    Icon: _socialInstagramOutline2.default
	  }, {
	    type: 'google plus',
	    url: ("https://plus.google.com/u/0/115535737505938510496/"),
	    color: theme.palette.social.googleplus,
	    Icon: _googlePlus2.default
	  }];
	
	  return socialMediaLinks.map(function (_ref2) {
	    var type = _ref2.type,
	        url = _ref2.url,
	        color = _ref2.color,
	        Icon = _ref2.Icon;
	    return _react2.default.createElement(
	      'a',
	      {
	        key: url,
	        href: url,
	        target: '_blank',
	        style: { margin: '0 2px', cursor: 'pointer' },
	        title: (0, _startCase2.default)(type)
	      },
	      _react2.default.createElement(Icon, {
	        style: {
	          color: dark ? '#fff' : color,
	          borderRadius: '50%',
	          background: dark ? color : '#fff',
	          padding: 4,
	          opacity: 0.9,
	          fontSize: '1.55em'
	        }
	      }),
	      _react2.default.createElement(
	        'style',
	        null,
	        '\n        span:hover {\n          opacity: 0.7;\n        }\n        '
	      )
	    );
	  });
	};
	
	FollowBar.propTypes = {
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _withTheme2.default)()((0, _pure2.default)(FollowBar));
	module.exports = exports['default'];

/***/ }),

/***/ 779:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Drawer = __webpack_require__(870);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _Divider = __webpack_require__(210);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _androidMenu = __webpack_require__(4054);
	
	var _androidMenu2 = _interopRequireDefault(_androidMenu);
	
	var _arrowDropDown = __webpack_require__(817);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _angleRight = __webpack_require__(4049);
	
	var _angleRight2 = _interopRequireDefault(_angleRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _burgerMenuIcon;
	
	  return {
	    burgerMenuIcon: (_burgerMenuIcon = {
	      position: 'relative',
	      left: 10,
	      fontSize: '2em',
	      cursor: 'pointer',
	      // background: theme.palette.secondary.dark,
	      borderRadius: 3,
	      transition: 'background 0.5s',
	      '&:hover': {
	        background: theme.palette.primary.main,
	        color: '#fff !important'
	      }
	    }, _burgerMenuIcon[theme.breakpoints.down('xs')] = {
	      fontSize: '1.6em'
	    }, _burgerMenuIcon),
	    burgerMenuCaption: {
	      display: 'inline-block',
	      marginLeft: 12,
	      fontWeight: 300,
	      fontSize: '0.7em',
	      textTransform: 'uppercase',
	      '&:hover': {
	        opacity: 1
	      }
	    },
	    drawerContainer: {},
	    drawerHeader: {
	      color: '#fff',
	      padding: 8,
	      minHeight: 50,
	      display: 'flex',
	      alignItems: 'center',
	      fontWeight: 300,
	      background: theme.palette.primary.main,
	      textTransform: 'uppercase'
	    },
	    drawerMainNavContainer: {
	      minWidth: 200,
	      display: 'block',
	      fontSize: '0.8em',
	      padding: 5,
	      '&:hover': {
	        // background: theme.palette.primary.main,
	        '& > a': {
	          // color: '#fff',
	          '&:hover': {
	            color: theme.palette.link.main
	          }
	        }
	      }
	    },
	    drawerMainNavLink: {
	      margin: '0 6px',
	      padding: '7px 0',
	      textTransform: 'uppercase',
	      color: theme.palette.link.nav,
	      fontSize: '0.9em',
	      fontWeight: 500
	    },
	    drawerSecondaryNavLinkContainer: {
	      padding: 11,
	      paddingLeft: 20,
	      fontSize: '0.8em',
	      '&:hover': {
	        background: theme.palette.primary.main,
	        '& > svg': {
	          fill: '#fff'
	        },
	        '& > p:first-child': {
	          color: theme.palette.link.hoveringOnSecondary
	        },
	        '& > a:first-child': {
	          color: theme.palette.link.hoveringOnSecondary
	        },
	        '& > a.drawerSecondaryChildNavLink': {
	          color: theme.palette.text.lighter,
	          '&:hover': {
	            color: theme.palette.link.hoveringOnSecondary
	          },
	          '& > svg': {
	            color: '#fff'
	          }
	        }
	      }
	    },
	    drawerSecondaryChildrenNavLink: {
	      paddingTop: 6,
	      fontSize: '0.9em',
	      color: theme.palette.text.soft,
	      '&:hover': {
	        color: '#74d5ff'
	      }
	    }
	  };
	};
	
	var Mobile = function (_React$Component) {
	  _inherits(Mobile, _React$Component);
	
	  function Mobile() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Mobile);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { open: false }, _this.toggleMenu = function () {
	      return _this.setState({ open: !_this.state.open });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Mobile.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        classes = _props.classes,
	        routes = _props.routes,
	        light = _props.light;
	    var state = this.state;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_androidMenu2.default, {
	        className: classes.burgerMenuIcon,
	        onClick: this.toggleMenu,
	        style: { color: light ? '#fff' : '#000' }
	      }),
	      _react2.default.createElement(
	        _Typography2.default,
	        {
	          variant: 'caption',
	          className: classes.burgerMenuCaption,
	          style: {
	            color: light ? '#fff' : '#000'
	          }
	        },
	        'Main Menu'
	      ),
	      _react2.default.createElement(
	        _Drawer2.default,
	        { open: state.open, onClose: this.toggleMenu },
	        _react2.default.createElement(
	          'div',
	          { className: classes.drawerContainer, onKeyDown: this.toggleMenu },
	          _react2.default.createElement(
	            _Typography2.default,
	            { className: classes.drawerHeader, variant: 'caption' },
	            _react2.default.createElement(_androidMenu2.default, {
	              className: classes.burgerMenuIcon,
	              onClick: this.toggleMenu
	            }),
	            '\xA0\xA0\xA0 Main Menu'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: classes.drawerMainNavContainer },
	            routes.main.map(function (_ref, i) {
	              var to = _ref.to,
	                  label = _ref.label;
	              return _react2.default.createElement(
	                _react.Fragment,
	                { key: i + to },
	                _react2.default.createElement(
	                  _Typography2.default,
	                  {
	                    key: 'mobile__main_route' + i,
	                    className: classes.drawerMainNavLink,
	                    component: _gatsbyLink2.default,
	                    to: to,
	                    onClick: _this2.toggleMenu
	                  },
	                  label
	                ),
	                _react2.default.createElement(_Divider2.default, null)
	              );
	            })
	          ),
	          routes.secondary.map(function (_ref2, i) {
	            var to = _ref2.to,
	                label = _ref2.label,
	                children = _ref2.children;
	
	            var otherProps = {};
	            if (to) {
	              otherProps.component = _gatsbyLink2.default;
	              otherProps.to = to;
	              otherProps.onClick = _this2.toggleMenu;
	            }
	            return _react2.default.createElement(
	              _react.Fragment,
	              { key: 'secondary_nav_link' + i },
	              _react2.default.createElement(
	                _Typography2.default,
	                {
	                  component: 'div',
	                  className: classes.drawerSecondaryNavLinkContainer
	                },
	                _react2.default.createElement(
	                  _Typography2.default,
	                  _extends({
	                    style: {
	                      display: 'inline-block',
	                      width: to ? '100%' : null
	                    }
	                  }, otherProps),
	                  label
	                ),
	                children && _react2.default.createElement(
	                  _react.Fragment,
	                  null,
	                  _react2.default.createElement(_arrowDropDown2.default, {
	                    style: {
	                      transform: 'scale(1.3)',
	                      position: 'relative',
	                      bottom: 1,
	                      fontSize: '1.8em'
	                    }
	                  }),
	                  _react2.default.createElement(_Divider2.default, { style: { marginBottom: 6 } }),
	                  children.map(function (childrenProps) {
	                    return _react2.default.createElement(
	                      _Typography2.default,
	                      {
	                        key: childrenProps.to,
	                        className: (0, _classnames2.default)(classes.drawerSecondaryChildrenNavLink, 'drawerSecondaryChildNavLink'),
	                        component: _gatsbyLink2.default,
	                        to: childrenProps.to,
	                        onClick: _this2.toggleMenu
	                      },
	                      _react2.default.createElement(_angleRight2.default, {
	                        style: {
	                          position: 'relative',
	                          top: -3,
	                          transform: 'scale(1.2)'
	                        }
	                      }),
	                      ' ',
	                      childrenProps.label
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(_Divider2.default, null)
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return Mobile;
	}(_react2.default.Component);
	
	Mobile.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  routes: _propTypes2.default.shape({
	    main: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	    secondary: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
	  }).isRequired,
	  light: _propTypes2.default.bool
	};
	
	exports.default = (0, _withStyles2.default)(styles)(Mobile);
	module.exports = exports['default'];

/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Mobile = __webpack_require__(779);
	
	var _Mobile2 = _interopRequireDefault(_Mobile);
	
	var _SecondaryLargeNav = __webpack_require__(931);
	
	var _SecondaryLargeNav2 = _interopRequireDefault(_SecondaryLargeNav);
	
	var _FollowBar = __webpack_require__(778);
	
	var _FollowBar2 = _interopRequireDefault(_FollowBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _root, _container, _mobileNavContainer;
	
	  return {
	    root: (_root = {
	      background: theme.palette.primary.main,
	      boxShadow: 'none',
	      display: 'none'
	    }, _root[theme.breakpoints.down('xs')] = {
	      display: 'block',
	      background: theme.palette.primary.main
	    }, _root),
	    container: (_container = {
	      padding: '6px 0',
	      margin: 'auto',
	      width: '100%',
	      display: 'flex',
	      justifyContent: 'space-between',
	      alignItems: 'center'
	    }, _container[theme.breakpoints.down('md')] = {
	      padding: '7px 40px'
	    }, _container[theme.breakpoints.down('xs')] = {
	      padding: '4px 15px',
	      justifyContent: 'start'
	    }, _container),
	    mobileNavContainer: (_mobileNavContainer = {
	      minWidth: 105,
	      display: 'none'
	    }, _mobileNavContainer[theme.breakpoints.down('xs')] = {
	      display: 'flex',
	      alignItems: 'center'
	    }, _mobileNavContainer),
	    followBar: {
	      fontSize: '0.8em'
	    }
	  };
	};
	
	var Secondary = function Secondary(_ref) {
	  var classes = _ref.classes,
	      routes = _ref.routes,
	      width = _ref.width;
	  return _react2.default.createElement(
	    'div',
	    { className: classes.root },
	    _react2.default.createElement(
	      'div',
	      { className: classes.container, style: { maxWidth: width } },
	      _react2.default.createElement(_SecondaryLargeNav2.default, { routes: routes }),
	      _react2.default.createElement(
	        'div',
	        { className: classes.mobileNavContainer },
	        _react2.default.createElement(_Mobile2.default, { routes: routes, light: true })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: classes.followBar },
	        _react2.default.createElement(_FollowBar2.default, null)
	      )
	    )
	  );
	};
	
	Secondary.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  routes: _propTypes2.default.shape({
	    main: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	    secondary: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
	  }).isRequired,
	  width: _propTypes2.default.number.isRequired
	};
	
	exports.default = (0, _withStyles2.default)(styles)(Secondary);
	module.exports = exports['default'];

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _SecondaryLargeNavItem = __webpack_require__(932);
	
	var _SecondaryLargeNavItem2 = _interopRequireDefault(_SecondaryLargeNavItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styles = function styles(theme) {
	  var _root;
	
	  return {
	    root: (_root = {
	      display: 'inline-block',
	      margin: 'auto'
	    }, _root[theme.breakpoints.down('xs')] = {
	      display: 'none'
	    }, _root)
	  };
	};
	
	var SecondaryLargeNav = function SecondaryLargeNav(_ref) {
	  var classes = _ref.classes,
	      routes = _ref.routes,
	      props = _objectWithoutProperties(_ref, ['classes', 'routes']);
	
	  return _react2.default.createElement(
	    'div',
	    _extends({ className: classes.root }, props),
	    routes.secondary.map(function (routeProps, i) {
	      return _react2.default.createElement(_SecondaryLargeNavItem2.default, _extends({
	        key: 'secondaryLargeNavItem' + i
	      }, routeProps));
	    })
	  );
	};
	
	SecondaryLargeNav.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  routes: _propTypes2.default.shape({
	    main: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	    secondary: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
	  }).isRequired
	};
	
	exports.default = (0, _withStyles2.default)(styles)(SecondaryLargeNav);
	module.exports = exports['default'];

/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _arrowDropDown = __webpack_require__(817);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    navLink: {
	      fontSize: '0.8em',
	      fontWeight: 400,
	      position: 'relative',
	      display: 'inline-block',
	      color: '#fff',
	      transition: 'color 0.5s',
	      padding: '2px 6px',
	      '&:hover': {
	        color: theme.palette.link.hoveringOnSecondary
	      }
	    },
	    navLinkOverAccent: {
	      position: 'relative',
	      display: 'inline-block',
	      color: '#fff',
	      transition: 'color 0.5s',
	      '&:hover': {
	        color: theme.palette.link.hoveringOnSecondary
	      }
	    },
	    dropdownNavLink: {
	      position: 'relative',
	      display: 'inline-block',
	      color: '#fff',
	      transition: 'color 0.5s',
	      padding: '2px 5px 2px 15px',
	      '&:hover': {
	        '& > div': {
	          // .dropdownInnerContainer
	          display: 'block'
	        }
	      }
	    },
	    dropdownContent: {
	      display: 'none',
	      position: 'absolute',
	      top: 31,
	      left: -2,
	      width: 300,
	      background: theme.palette.background.light,
	      border: '1px solid #ddd',
	      zIndex: 1
	    },
	    dropdownItem: {
	      fontSize: '0.95em',
	      color: '#fff',
	      padding: 8,
	      textDecoration: 'none',
	      display: 'block',
	      transition: 'background 0.6s, color 0.6s',
	      background: theme.palette.primary.main,
	      '&:hover': {
	        opacity: 1,
	        color: theme.palette.link.nav,
	        background: '#fff',
	        '& > span.label': {
	          color: theme.palette.link.main
	        }
	      }
	    },
	    attentionStyle: {
	      cursor: 'default',
	      fontWeight: 500,
	      border: '1px solid #7ca7b1',
	      backgroundColor: theme.palette.primary.mainDarker
	    },
	    arrowDown: {
	      transform: 'scale(1.3)',
	      position: 'relative',
	      bottom: 1,
	      fontSize: '1.8em'
	    }
	  };
	};
	
	// For large screens only
	var SecondaryLargeNavItem = function SecondaryLargeNavItem(_ref) {
	  var _cx2;
	
	  var classes = _ref.classes,
	      theme = _ref.theme,
	      to = _ref.to,
	      label = _ref.label,
	      children = _ref.children,
	      attention = _ref.attention;
	
	  var frontLabel = null;
	  var linkProps = {};
	
	  if (children) {
	    if (to) {
	      frontLabel = _react2.default.createElement(
	        _Typography2.default,
	        {
	          component: _gatsbyLink2.default,
	          to: to,
	          style: { color: '#fff' },
	          activeStyle: { color: theme.palette.primary.lighter }
	        },
	        label,
	        _react2.default.createElement(_arrowDropDown2.default, { className: classes.arrowDown })
	      );
	    } else {
	      frontLabel = _react2.default.createElement(
	        'span',
	        { className: classes.navLinkOverAccent },
	        label,
	        _react2.default.createElement(_arrowDropDown2.default, { className: classes.arrowDown })
	      );
	    }
	  } else {
	    var _cx;
	
	    frontLabel = _react2.default.createElement(
	      _Typography2.default,
	      {
	        component: _gatsbyLink2.default,
	        to: to,
	        activeStyle: { color: theme.palette.primary.lighter },
	        className: (0, _classnames2.default)(classes.navLink, (_cx = {}, _cx[classes.attentionStyle] = attention === true, _cx))
	      },
	      label,
	      '\xA0\xA0\xA0\xA0\xA0'
	    );
	  }
	
	  return children ? _react2.default.createElement(
	    _Typography2.default,
	    {
	      component: 'div',
	      className: (0, _classnames2.default)(classes.dropdownNavLink, (_cx2 = {}, _cx2[classes.attentionStyle] = attention === true, _cx2))
	    },
	    frontLabel,
	    children && _react2.default.createElement(
	      'div',
	      { className: classes.dropdownContent },
	      children.map(function (props) {
	        var linkProps = {};
	        if (props.outbound) {
	          linkProps.component = 'a';
	          linkProps.href = props.to;
	        } else {
	          linkProps.component = _gatsbyLink2.default;
	          linkProps.to = props.to;
	        }
	        return _react2.default.createElement(
	          _Typography2.default,
	          _extends({
	            key: props.to,
	            className: classes.dropdownItem
	          }, linkProps, {
	            noWrap: true
	          }),
	          props.sublabel ? _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              props.label
	            ),
	            '\xA0',
	            ' ',
	            _react2.default.createElement(
	              'span',
	              { className: 'sublabel' },
	              '(',
	              props.sublabel,
	              ')'
	            )
	          ) : props.label
	        );
	      })
	    )
	  ) : frontLabel;
	};
	
	SecondaryLargeNavItem.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired,
	  to: _propTypes2.default.string,
	  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
	  children: _propTypes2.default.array,
	  attention: _propTypes2.default.bool
	};
	
	exports.default = (0, _withStyles2.default)(styles, { withTheme: true })(SecondaryLargeNavItem);
	module.exports = exports['default'];

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _AppBar = __webpack_require__(155);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	var _siteConfig = __webpack_require__(776);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _logo2 = __webpack_require__(4275);
	
	var _logo3 = _interopRequireDefault(_logo2);
	
	var _FollowBar = __webpack_require__(778);
	
	var _FollowBar2 = _interopRequireDefault(_FollowBar);
	
	var _Mobile = __webpack_require__(779);
	
	var _Mobile2 = _interopRequireDefault(_Mobile);
	
	var _Secondary = __webpack_require__(930);
	
	var _Secondary2 = _interopRequireDefault(_Secondary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _logo, _navigation, _navigationDesktop, _navigationMobile, _followBar, _navigationLink;
	
	  return {
	    logoWrapper: {
	      position: 'relative',
	      width: 230,
	      height: 50,
	      left: 30
	      // overflow: 'hidden',
	    },
	    logo: (_logo = {
	      position: 'absolute',
	      top: -70,
	      // top: -90,
	      // maxWidth: 220,
	      width: '100%',
	      // height: 180,
	      // position: 'absolute',
	      clip: 'rect(0px, auto, 120px, 0px)'
	    }, _logo[theme.breakpoints.down('xs')] = {
	      transform: 'scale(0.7)'
	    }, _logo),
	    navigation: (_navigation = {
	      position: 'absolute',
	      width: '100%',
	      margin: 'auto',
	      textAlign: 'center'
	    }, _navigation[theme.breakpoints.down('sm')] = {
	      textAlign: 'left',
	      left: 260
	    }, _navigation[theme.breakpoints.down('xs')] = {
	      left: 175,
	      transform: 'scale(0.9)'
	    }, _navigation),
	    navigationDesktop: (_navigationDesktop = {
	      display: 'inline-block'
	    }, _navigationDesktop[theme.breakpoints.down('sm')] = {
	      display: 'none'
	    }, _navigationDesktop),
	    navigationMobile: (_navigationMobile = {
	      minWidth: 110,
	      display: 'none'
	    }, _navigationMobile[theme.breakpoints.down('sm')] = {
	      display: 'inline-block'
	    }, _navigationMobile[theme.breakpoints.down('xs')] = {
	      display: 'none'
	    }, _navigationMobile),
	    followBar: (_followBar = {
	      padding: 1,
	      position: 'absolute',
	      right: 0
	    }, _followBar[theme.breakpoints.down('xs')] = {
	      display: 'none'
	    }, _followBar),
	    navigationLink: (_navigationLink = {
	      margin: '0 8px',
	      textTransform: 'uppercase',
	      display: 'inline-block',
	      color: theme.palette.link.nav,
	      fontSize: '0.9em',
	      fontWeight: 500
	    }, _navigationLink[theme.breakpoints.down('md')] = {
	      fontSize: '0.8em'
	    }, _navigationLink)
	  };
	};
	
	var Navigation = function Navigation(_ref) {
	  var classes = _ref.classes,
	      theme = _ref.theme,
	      width = _ref.width;
	
	  if (!width) {
	    throw new Error('Please provide a width for the navigation');
	  }
	  var routes = {
	    main: [
	    // { to: '/', label: 'Home' },
	    // { to: '/about', label: 'About' },
	    // { to: '/contact', label: 'Contact' },
	    { to: '/', label: 'HOME' }, { label: 'ARTICLES', to: '/weight-loss-articles' }, { label: 'STORIES', to: '/weight-loss-stories' }, {
	      label: 'WORKOUTS',
	      to: '/weight-loss-workouts'
	    }, { to: '/about', label: 'ABOUT' }, { to: '/contact', label: 'CONTACT' }],
	    secondary: [
	      // { to: '/', label: 'HOME' },
	      // { label: 'ARTICLES', to: '/weight-loss-articles' },
	      // { label: 'STORIES', to: '/weight-loss-stories' },
	      // {
	      //   label: 'WORKOUTS',
	      //   to: '/weight-loss-workouts',
	      // },
	      // { to: '/about', label: 'ABOUT' },
	      // { to: '/contact', label: 'CONTACT' },
	    ]
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _AppBar2.default,
	      { position: 'fixed', style: { boxShadow: '0px 0px 2px #b6b6b6' } },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              display: 'flex',
	              alignItems: 'center',
	              background: theme.palette.background.light,
	              boxShadow: 'none',
	              minHeight: 50
	            }
	          },
	          _react2.default.createElement(
	            'nav',
	            {
	              style: {
	                width: width,
	                margin: 'auto',
	                position: 'relative',
	                display: 'flex',
	                alignItems: 'center'
	              }
	            },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/', title: _siteConfig2.default.siteTitle },
	              _react2.default.createElement(
	                'div',
	                { className: classes.logoWrapper },
	                _react2.default.createElement('img', {
	                  src: _logo3.default,
	                  className: classes.logo,
	                  alt: _siteConfig2.default.siteTitle,
	                  title: _siteConfig2.default.siteTitle
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: classes.navigation },
	              _react2.default.createElement(
	                'div',
	                { className: classes.navigationMobile },
	                _react2.default.createElement(_Mobile2.default, { routes: routes })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: classes.navigationDesktop },
	                routes.main.map(function (_ref2, i) {
	                  var to = _ref2.to,
	                      label = _ref2.label;
	                  return _react2.default.createElement(
	                    _Typography2.default,
	                    {
	                      key: 'nav-link' + i,
	                      className: classes.navigationLink,
	                      component: _gatsbyLink2.default,
	                      to: to
	                    },
	                    label
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: classes.followBar },
	              _react2.default.createElement(_FollowBar2.default, { dark: true })
	            )
	          )
	        ),
	        _react2.default.createElement(_Secondary2.default, { routes: routes, width: width })
	      )
	    )
	  );
	};
	
	Navigation.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
	};
	
	exports.default = (0, _withStyles2.default)(styles, { withTheme: true })(Navigation);
	module.exports = exports['default'];

/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(64);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(127);
	
	var _pure = __webpack_require__(49);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _Input = __webpack_require__(67);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _TextField = __webpack_require__(260);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _LinearProgress = __webpack_require__(159);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	var _androidCheckmarkCircle = __webpack_require__(208);
	
	var _androidCheckmarkCircle2 = _interopRequireDefault(_androidCheckmarkCircle);
	
	var _compose = __webpack_require__(47);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _app = __webpack_require__(131);
	
	var _regexp = __webpack_require__(290);
	
	var _regexp2 = _interopRequireDefault(_regexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styles = function styles(theme) {
	  var _successText;
	
	  return {
	    form: {
	      position: 'absolute',
	      width: '100%',
	      height: '100%'
	    },
	    input: {
	      marginBottom: theme.spacing.unit,
	      color: '#fff',
	      fontWeight: 300
	    },
	    label: {
	      color: '#fff',
	      fontWeight: 300,
	      fontSize: '0.8em'
	    },
	    buttonContainer: {
	      padding: '10px 0'
	    },
	    button: {
	      fontSize: '0.8em',
	      fontWeight: 300,
	      border: '1px solid ' + theme.palette.borders.cloud,
	      background: theme.palette.primary.main,
	      color: '#fff',
	      '&:hover': {
	        color: theme.palette.text.main,
	        background: theme.palette.background.lightAlternate
	      }
	    },
	    successText: (_successText = {
	      color: theme.palette.text.lighter
	    }, _successText[theme.breakpoints.down('sm')] = {
	      fontSize: '0.8em'
	    }, _successText),
	    errorText: {
	      color: theme.palette.error.light
	    },
	    checkIcon: {
	      color: theme.palette.successLighter,
	      fontSize: '2.5em'
	    }
	  };
	};
	
	var renderTextField = function renderTextField(_ref) {
	  var input = _ref.input,
	      _ref$meta = _ref.meta,
	      touched = _ref$meta.touched,
	      error = _ref$meta.error,
	      errorTextClassName = _ref.errorTextClassName,
	      customProps = _objectWithoutProperties(_ref, ['input', 'meta', 'errorTextClassName']);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_TextField2.default, _extends({ error: touched && !!error }, input, customProps)),
	    touched && error && _react2.default.createElement(
	      _Typography2.default,
	      { className: errorTextClassName },
	      error
	    )
	  );
	};
	
	var SubscribeForm = function SubscribeForm(_ref2) {
	  var classes = _ref2.classes,
	      submitting = _ref2.submitting,
	      handleSubmit = _ref2.handleSubmit,
	      submitSucceeded = _ref2.submitSucceeded;
	
	  var actionProps = {};
	  var oldBrowser = false;
	
	  if (typeof Promise !== 'undefined' && Promise.toString().indexOf('[native code]') !== -1) {
	    actionProps.onSubmit = handleSubmit;
	  } else {
	    oldBrowser = true;
	    actionProps.action = ("https://app.getresponse.com/add_subscriber.html");
	    actionProps.method = 'post';
	  }
	
	  return _react2.default.createElement(
	    'form',
	    _extends({
	      style: { opacity: submitting ? 0.4 : 1 },
	      className: classes.form
	    }, actionProps),
	    _react2.default.createElement(_LinearProgress2.default, {
	      color: 'secondary',
	      style: {
	        position: 'relative',
	        width: '100%',
	        marginBottom: 5,
	        visibility: submitting ? 'visible' : 'hidden'
	      }
	    }),
	    !submitSucceeded && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      !oldBrowser && _react2.default.createElement(_reduxForm.Field, {
	        errorTextClassName: classes.errorText,
	        InputProps: { className: classes.input },
	        InputLabelProps: { className: classes.label },
	        name: 'email',
	        label: 'Email',
	        component: renderTextField,
	        type: 'email',
	        required: true,
	        fullWidth: true
	      }),
	      oldBrowser && _react2.default.createElement(_Input2.default, {
	        inputProps: { className: classes.input },
	        name: 'email',
	        type: 'email',
	        placeholder: 'Email',
	        required: true,
	        fullWidth: true
	      }),
	      oldBrowser && _react2.default.createElement('input', {
	        type: 'hidden',
	        name: 'thankyou_url',
	        value: window.location.href
	      }),
	      _react2.default.createElement('input', { type: 'hidden', name: 'campaign_token', value: '6qdpg' }),
	      _react2.default.createElement(
	        'div',
	        { className: classes.buttonContainer },
	        _react2.default.createElement(
	          _Button2.default,
	          { className: classes.button, type: 'submit', variant: 'flat' },
	          'SUBSCRIBE'
	        )
	      )
	    ),
	    submitSucceeded && _react2.default.createElement(
	      _Typography2.default,
	      { className: classes.successText },
	      _react2.default.createElement(_androidCheckmarkCircle2.default, { className: classes.checkIcon }),
	      ' You\'re now subscribed!'
	    )
	  );
	};
	
	SubscribeForm.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  subscribe: _propTypes2.default.func.isRequired,
	  sendAlert: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _compose2.default)((0, _withStyles2.default)(styles), (0, _reactRedux.connect)(null, { subscribe: _app.subscribe, sendAlert: _app.sendAlert }), (0, _reduxForm.reduxForm)({
	  form: 'SubscribeForm',
	  onSubmit: function onSubmit(values, _, _ref3) {
	    var subscribeUser = _ref3.subscribe,
	        reset = _ref3.reset,
	        sendAlert = _ref3.sendAlert;
	    return subscribeUser(_extends({ campaignToken: '6qdpg' }, values)).then(function () {
	      sendAlert({
	        message: "Awesome! You're now subscribed!",
	        type: 'success'
	      });
	      return reset();
	    }).catch(function () {
	      return sendAlert({
	        message: 'The email is either already registered or an error occurred. Please try again later.',
	        type: 'error'
	      });
	    });
	  },
	  validate: function validate(_ref4) {
	    var email = _ref4.email;
	
	    var errors = {};
	    if (!email) {
	      errors.email = 'Please provide your email.';
	    }
	    if (!_regexp2.default.email.test(email)) {
	      errors.email = 'Please provide a valid email.';
	    }
	    return errors;
	  }
	}), _pure2.default)(SubscribeForm);
	module.exports = exports['default'];

/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRedux = __webpack_require__(64);
	
	var _Alert = __webpack_require__(913);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _app = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    alert: state.app.alert
	  };
	};
	
	var mapDispatchToProps = {
	  closeAlert: _app.closeAlert
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Alert2.default);
	module.exports = exports['default'];

/***/ }),

/***/ 969:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {'use strict';
	
	exports.__esModule = true;
	exports.default = getPageContext;
	
	var _jss = __webpack_require__(226);
	
	var _createGenerateClassName = __webpack_require__(264);
	
	var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);
	
	var _theme = __webpack_require__(213);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPageContext() {
	  return {
	    theme: _theme2.default,
	    // This is needed in order to deduplicate the injection of CSS in the page.
	    sheetsManager: new Map(),
	    // This is needed in order to inject the critical CSS.
	    sheetsRegistry: new _jss.SheetsRegistry(),
	    // The standard class name generator.
	    generateClassName: (0, _createGenerateClassName2.default)()
	  };
	} /* eslint-disable no-underscore-dangle */
	
	function getPageContext() {
	  // Make sure to create a new context for every server-side request so that data
	  // isn't shared between connections (which would be bad).
	  if (!process.browser) {
	    return createPageContext();
	  }
	
	  // Reuse context on the client-side.
	  if (!global.__INIT_MATERIAL_UI__) {
	    global.__INIT_MATERIAL_UI__ = createPageContext();
	  }
	
	  return global.__INIT_MATERIAL_UI__;
	}
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54), (function() { return this; }())))

/***/ }),

/***/ 4275:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.7eaf12e4.png";

/***/ }),

/***/ 1080:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(729);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withRoot = __webpack_require__(998);
	
	var _withRoot2 = _interopRequireDefault(_withRoot);
	
	var _Navigation = __webpack_require__(933);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Footer = __webpack_require__(920);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Alert = __webpack_require__(967);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	__webpack_require__(1080);
	
	__webpack_require__(1073);
	
	__webpack_require__(1075);
	
	__webpack_require__(1074);
	
	__webpack_require__(1077);
	
	__webpack_require__(1076);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	
	  var navigationWidth = 1180;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: data.site.siteMetadata.siteTitle,
	      meta: [{
	        name: 'description',
	        content: data.site.siteMetadata.siteDescription
	      }]
	    }),
	    _react2.default.createElement(_Navigation2.default, { width: navigationWidth }),
	    _react2.default.createElement('div', { className: 'spacing-normalizer' }),
	    children(),
	    _react2.default.createElement(_Footer2.default, null),
	    _react2.default.createElement(_Alert2.default, null)
	  );
	};
	// import 'rc-select/assets/index.css'
	
	
	Layout.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  data: _propTypes2.default.object.isRequired
	
	  // eslint-disable-next-line
	};var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = (0, _withRoot2.default)(Layout);

/***/ }),

/***/ 998:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _MuiThemeProvider = __webpack_require__(770);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _CssBaseline = __webpack_require__(868);
	
	var _CssBaseline2 = _interopRequireDefault(_CssBaseline);
	
	var _getPageContext = __webpack_require__(969);
	
	var _getPageContext2 = _interopRequireDefault(_getPageContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withRoot(Component) {
	  var WithRoot = function (_React$Component) {
	    _inherits(WithRoot, _React$Component);
	
	    function WithRoot(props, context) {
	      _classCallCheck(this, WithRoot);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	      _this.pageContext = null;
	
	
	      _this.pageContext = _this.props.pageContext || (0, _getPageContext2.default)();
	      return _this;
	    }
	
	    WithRoot.prototype.componentDidMount = function componentDidMount() {
	      // Remove the server-side injected CSS.
	      // eslint-disable-next-line
	      var jssStyles = document.querySelector('#server-side-jss');
	      if (jssStyles && jssStyles.parentNode) {
	        jssStyles.parentNode.removeChild(jssStyles);
	      }
	    };
	
	    WithRoot.prototype.render = function render() {
	      // MuiThemeProvider makes the theme available down the React tree thanks to React context.
	      return _react2.default.createElement(
	        _MuiThemeProvider2.default,
	        {
	          theme: this.pageContext.theme,
	          sheetsManager: this.pageContext.sheetsManager
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_CssBaseline2.default, null),
	          _react2.default.createElement(Component, this.props)
	        )
	      );
	    };
	
	    return WithRoot;
	  }(_react2.default.Component);
	
	  WithRoot.propTypes = {
	    pageContext: _propTypes2.default.object
	  };
	
	  return WithRoot;
	}
	
	exports.default = withRoot;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-ff5c12342952f0bcb96f.js